(window.webpackJsonp=window.webpackJsonp||[]).push([[520],{
/***/"+g2F":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }
  .counter {
    margin-top: 0px;
  }
  .process-step-container {
    color: #475c7b;
    background-color: rgb(255, 255, 255);
    font-size: 14px;
    line-height: 23px;
    border-width: 1px 1px 5px;
    border-style: solid;
    border-color: rgb(212, 212, 212) rgb(212, 212, 212) rgb(221, 221, 221);
    border-image: initial;
    border-radius: 4px;
    padding: 15px;
    border-bottom: 5px solid rgb(221, 221, 221);
  }
  .process-step-body {
    margin-bottom: 20px;
    padding: 5px;
    border-radius: 3px;
    border: 1px solid rgb(212, 212, 212);
  }
  .process-step-body h4 {
    margin-block-start: 0;
  }
  .process-step-body p {
    font-size: 12px;
    margin: 0;
    padding: 0;
  }
  .process-step-container .badge {
    float: none;
    text-align: center;
  }
  .process-step-container p {
    float: none;
    text-align: center;
  }
  .panel {
    height: auto;
  }
  .small-height {
    height: auto;
  }
`
/***/},
/***/"0/Fl":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .btn.btn-xs.star {
    font-size: 11px;
    height: 26px;
    line-height: 26px;
    margin-top: 3px !important;
    text-align: center !important;
    border-radius: 4px;
    padding: 0px 8px !important;
    position: absolute;
    top: 7px;
    right: 45px;
    z-index: 100;
    background: green;
    color: rgb(255, 255, 255);
    border-width: 1px;
    border-style: solid;
    border-color: green;
    border-image: initial;
  }
`
/***/},
/***/"1DjL":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  iron-icon.small {
    font-size: 14px;
    width: 16px;
    height: 16px;
    margin-left: 5px;
  }

  iron-icon.medium {
    font-size: 17px;
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  iron-icon.blue {
    color: #38b5ed;
  }

  iron-icon.green {
    color: #2a4a60;
    margin-top: 5px;
  }

  iron-icon.orange {
    color: #fc991a;
    cursor: pointer;
    float: right;
  }
`
/***/},
/***/"6haZ":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }
`
/***/},
/***/"7Wl+":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
  .commessa {
    list-style: none;
    background-color: #fff;
    margin-bottom: 0px;
    border-radius: 0px;
    height: 54px;
    color: var(--app-primary-color);
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    position: relative;
    border-bottom: 1px dotted rgba(67, 82, 99, 0.3) !important;
  }

  .commessa:hover {
    background-color: rgba(67, 82, 99, 0.1);
    transition: transform 0.4s ease-out, -webkit-transform 0.4s ease-out;
  }

  .commessa .icon {
    background-color: var(--app-primary-color);
    cursor: pointer;
    height: 54px;
    line-height: 54px;
    width: 54px;
    border-radius: 0px;
    text-align: center;
    color: #fff;
    position: absolute;
    left: 0px;
    -webkit-transition: color 300ms, background-color 200ms;
    -moz-transition: color 300ms, background-color 200ms;
    -o-transition: color 300ms, background-color 200ms;
    transition: color 300ms, background-color 200ms;
    border-bottom: 1px solid #fff;
  }

  .commessa .icon.shipment {
    cursor: pointer;
    height: 54px;
    line-height: 54px;
    width: 54px;
    border-radius: 0px;
    text-align: center;
    color: var(--app-primary-color);
    position: absolute;
    left: 0px;
    -webkit-transition: color 300ms, background-color 200ms;
    -moz-transition: color 300ms, background-color 200ms;
    -o-transition: color 300ms, background-color 200ms;
    transition: color 300ms, background-color 200ms;
    border-bottom: 1px solid #fff;
  }

  .commessa.active {
    background-color: rgba(67, 82, 99, 0.1);
    list-style: none;
    margin-bottom: 0px;
    border-radius: 0px;
    height: 54px;
  }

  .commessa.active .icon {
    background-color: var(--app-selected-color);
    list-style: none;
    cursor: pointer;
    margin-bottom: 10px;
    border-radius: 0px;
    float: left;
    height: 54px;
  }

  .commessa:hover .icon {
    background-color: #4fc1e9;
  }

  .commessa .content {
    padding: 7px 20px;

    color: var(--app-primary-color);
    cursor: pointer;
    position: absolute;
    left: 54px;
    right: 54px;
    width: calc(100% - 53px);
  }

  .commessa .content .title {
    padding: 0px;
    float: left;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }

  .commessa .content .title h3 {
    margin: 0px;
    padding: 0px;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    width: calc(100% - 120px);
  }

  .commessa .content .description {
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    float: left;
    width: calc(100% - 120px);
  }

  .commessa .content .description.hidden six-badge {
    display: none;
  }

  .commessa .content .description p {
    float: left;
    margin: 0px;
    padding: 0px;
    margin-left: 0px;
  }

  .commessa .content .description p.spaced {
    margin-right: 10px !important;
  }

  .commessa .button {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 54px;
    text-align: center;
    line-height: 70px;
    width: 120px;
  }

  .selected-kit {
    background-color: red;
  }
  .selected-dest {
    background-color: yellow;
  }

  .selectedDDT{
    background-color:#99e6ff;
  }
`
/***/},
/***/"8y/O":
/***/function(c,t,o){"use strict";
/* unused harmony export orderProgressListStyles */
/* harmony import */o("Rukz").c`
  .label-quantity-active {
    text-align: center;
    line-height: 20px !important;
  }
`
/***/},
/***/A65m:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
  .commessa {
    list-style: none;
    background-color: #fff;
    margin-bottom: 0px;
    border-radius: 0px;
    height: 54px;
    color: var(--app-primary-color);
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    position: relative;
    border-bottom: 1px solid rgba(67, 82, 99, 0.3);
  }

  .commessa:hover {
    background-color: rgba(67, 82, 99, 0.1);
    transition: transform 0.4s ease-out, -webkit-transform 0.4s ease-out;
  }

  .commessa .icon {
    background-color: var(--app-primary-color);
    border-bottom: 0px solid #ccc;
    cursor: pointer;
    height: 54px;
    line-height: 54px;
    width: 54px;
    border-radius: 0px;
    text-align: center;
    color: #fff;
    position: absolute;
    left: 0px;
  }

  .commessa.active {
    background-color: rgba(67, 82, 99, 0.1);

    list-style: none;
    margin-bottom: 0px;
    border-radius: 0px;
    height: 11%;
  }

  .commessa.active .icon {
    background-color: var(--app-selected-color);
    list-style: none;
    cursor: pointer;
    margin-bottom: 10px;
    border-radius: 0px;
    float: left;
    height: 54px;
  }

  .commessa .content {
    padding: 7px 20px;

    color: var(--app-primary-color);
    cursor: pointer;
    position: absolute;
    left: 54px;
    right: 54px;
    width: calc(100% - 100px);
  }

  .commessa .content .title {
    padding: 0px;
    float: left;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
  }

  .commessa .content .title h3 {
    margin: 0px;
    padding: 0px;
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    width: calc(100% - 40px);
  }

  .commessa .content .description {
    margin: 0px;
    padding: 0px;
    font-size: 12px;
    float: left;
    width: calc(100% - 40px);
  }

  .commessa .content .description.hidden six-badge {
    display: none;
  }

  .commessa .content .description p {
    float: left;
    margin: 0px;
    padding: 0px;
    margin-left: 0px;
  }

  .commessa .content .description p.spaced {
    margin-left: 10px !important;
  }

  .commessa .button {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 54px;
    text-align: center;
    line-height: 70px;
    width: 54px;
  }

  .list {
    height: 11%;
  }
  .containerBox {
    height: 450px;
    overflow-y: auto;
  }
  .noPadding {
    padding-inline-start: 0px;
  }
`
/***/},
/***/C5Fa:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  six-button {
    padding: 0px;
    margin: 0px;
  }

  iron-overlay-backdrop:host(.opened) {
    opacity: var(--iron-overlay-backdrop-opacity, 0.6);
    pointer-events: auto;
    background-color: var(--iron-overlay-backdrop-background-color, #222) !important;
  }

  paper-dialog {
    max-width: 500px;
  }

  paper-dialog .dialog-footer {
    padding: 0px !important;
  }

  .nav-slides {
    overflow: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .nav-list {
    list-style: none;
    white-space: nowrap;
    padding: 0px;
    padding-left: 0;
    font-size: 16px;
    margin-bottom: 0px;
  }

  .nav-list li {
    display: inline-block;
    margin-right: 7px;
    position: relative;
  }

  .image-container img {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    object-fit: contain;
    object-position: center center;
  }

  .nav-list li img {
    width: 80px;
  }

  .image-container {
    height: 300px;
    background-color: #efefef;
  }

  video {
    width: 100%;
    object-fit: contain;
    object-position: center center;
  }

  canvas {
    width: 100%;
    object-fit: contain;
    object-position: center center;
  }

  .blue-area {
    background-color: #efefef;
    height: 100%;
  }
`
/***/},
/***/CfOG:
/***/function(c,t,o){"use strict";
/* unused harmony export serialkitQuickCreationViewStyles */
/* harmony import */o("Rukz").c`
  .page {
    display: none;
  }

  .page[active] {
    display: block;
  }

  .importbox {
    padding: 15px;
  }

  .counter .wrapper .success {
    background-color: green;
    color: #fff;
    font-weight: bold;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    float: left;
    padding: 0px 8px;
    border-radius: 4px 0px 0px 4px;
  }

  .counter .wrapper .error {
    background-color: red;
    color: #fff;
    font-weight: bold;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    float: left;
    padding: 0px 8px;
    border-radius: 0px 4px 4px 0px;
  }
`
/***/},
/***/DXej:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .danger {
    background: #fc6b4c;
  }

  .success {
    background: #44c455;
  }

  .warning {
    background: #fcbf4c;
  }

  .selected {
    background: #d6e3ee;
  }
`
/***/},
/***/HesL:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .history-modified {
    background-color: #ffffcc;
  }

  .history-container {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
  }

  .history-label {
    flex-grow: 0;
    align-self: center;
    width: 100%;
    word-wrap: break-word;
  }

  .history-value-container {
    display: flex;
    flex-direction: row;
  }

  .history-value {
    flex-grow: 0;
    width: 45%;
    align-self: center;
  }

  .history-arrow {
    flex-grow: 0;
    align-self: center;
    width: 5%;
    text-align: center;
    padding-bottom: 8px;
  }

  .row-deleted {
    background: #dc143c;
    color: white;
  }

  .row-added {
    background: #adff2f;
  }

  .row-modified {
    background: #ffff99;
  }
`
/***/},
/***/HhPD:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/Kqj9:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .form-group {
    margin-bottom: 10px;
  }

  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }
`
/***/},
/***/"LDH+":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }
  .counter {
    margin-top: 0px;
  }
`
/***/},
/***/OOsI:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/TDlB:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .page {
    display: none;
  }

  .page[active] {
    display: block;
  }
`
/***/},
/***/TIRO:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/U48y:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/UNYr:
/***/function(c,t,o){"use strict";
/* harmony import */o("KR5w"),o("e0ld")
/* harmony import */;const r=document.createElement("template");r.innerHTML='<iron-iconset-svg name="ict" size="512"><svg><defs><g id="sterile"><path d="M87.2,318.7c10.3-10.3,19.9-20,29.5-29.6c17.2-17.2,34.1-34.6,51.6-51.5c14.7-14.2,37.3-10.7,48.2,5.4c0.8,1.2,1.7,2.4,2.7,3.9c6.4-7.5,14-12.4,23.8-13c7.8-0.5,15,1.5,21.3,6.2c10.3,7.6,17.5,23.3,8.7,41.5c11.5,5.9,18.3,15.1,18.8,28.4c0.6,13.4-7,22.4-16.7,30.7c5.9,3,10.5,6.9,13.7,12.4c7.3,12.3,5.7,28.8-5.2,39.6c-22.1,21.8-44,43.8-66,65.8c-6.7,6.7-13.3,13.6-20.1,20.2c-5.1,5-12.9,3.9-16.4-2c-2.5-4.3-1.8-9.7,1.8-13.3c11.2-11.2,22.4-22.4,33.6-33.6c9.5-9.5,19.1-19,28.6-28.5c8.1-8.1,16.3-16.1,24.4-24.2c3.7-3.7,3.9-10.7,0.2-14.5c-4.1-4.2-9.8-5.4-14.8-1c-4.5,3.9-8.6,8.2-12.9,12.4c-4.8,4.8-9.5,9.7-14.3,14.5c-7.8,7.9-15.7,15.8-23.5,23.7c-2.9,2.9-5.8,5.8-8.8,8.4c-4.5,3.9-10.6,3.3-14.7-1.2c-3.5-3.8-3.4-10.1,0.5-14.1c4.9-5.1,10-10,15-14.9c22.8-22.7,45.5-45.5,68.2-68.3c2.6-2.6,5.7-4.9,6.2-9.1c0.5-4.3-1-8.6-4.7-10.9c-3.4-2.1-9.2-2-12.2,0.7c-4.1,3.7-8.1,7.6-12,11.5c-11.1,11.1-22.1,22.2-33.1,33.3c-9,9-18,18-26.9,27c-4.1,4.1-11.3,4.6-15.2,0.4c-4-4.3-5.2-10,0.1-15.3c25.4-25.5,50.8-50.9,76.3-76.3c3.2-3.2,6.3-6.3,9.5-9.5c3.4-3.4,4.6-7.5,3-12.1c-1.5-4.3-5.1-6.5-9.1-6.6c-2.8-0.1-6.3,1.4-8.3,3.3c-11.9,11.4-23.5,23.2-35.2,34.9c-18.6,18.6-37.2,37.2-55.8,55.8c-4,4-11,4.1-15,0.2c-4-3.9-3.8-11.5,0.2-15.5c21.9-21.6,43.5-43.4,65.3-65.1c5.5-5.5,4-14.9-3-17.8c-3.7-1.5-8.4-0.9-11.7,2.4c-9.8,9.7-19.6,19.5-29.4,29.3c-22.8,22.8-45.5,45.6-68.3,68.4c-3.3,3.3-8.3,4.5-12.2,2.7c-4.4-2-6.4-5.6-6.4-10.4c0-20.6,0-41.2,0-61.8c0-5.7-3.8-11-8.7-12.3c-6-1.6-11.3,0.3-14.1,5.6c-1.2,2.3-1.5,5.4-1.5,8.1c-0.1,32.5-0.1,65.1-0.2,97.6c0,3.7-0.1,7.3-3.1,10.2c-3.5,3.3-7.1,4.4-11.2,2.8c-4.3-1.7-7-5.4-7-10c0-8.3,0-16.6,0-24.9c0-25.6,0-51.2,0-76.9c0-17.1,10.8-31.1,27.5-33.9c16.1-2.7,31.7,5.4,37.1,21.8c1.3,4,1.9,8.4,2,12.7C87.4,294.2,87.2,306,87.2,318.7z"/><path d="M435.9,321.9c0-39.7,0-79.4,0-119c0-4.2,1.8-7.6,5.5-9.7c3.5-2,7.3-1.9,10.8,0.1c3.7,2.3,5.3,6,5.3,10.2c0,12.5-0.2,25.1-0.2,37.6c0,19.3,0.2,38.6,0.2,57.9c0,46,0,92,0,138c0,24.4-15.4,43.3-39.3,48c-2.7,0.5-5.6,0.7-8.4,0.8c-43.3,0-86.6,0-129.8,0c-10.6,0-21.3,0-31.9,0c-6.5,0-11.6-4.7-11.7-10.6c-0.1-6.3,4.6-11,11-11c17.9,0,35.8,0,53.6,0c36.8,0,73.7,0,110.5,0c12.9,0,24.3-11.3,24.3-24.2C435.9,400.7,435.9,361.3,435.9,321.9z"/><path d="M206.5,71.7c39.9,0,79.8,0.1,119.7-0.1c6,0,10.8,5.1,10.9,10.5c0.2,5.9-5.8,10.7-10.8,10.6c-78.3-0.2-156.5-0.1-234.8-0.1c-15.6,0-27.2,10.6-27.2,27.4c-0.1,30.7-0.1,61.5,0.1,92.2c0,6.1-4.5,11.2-10.4,11.3c-6.2,0.1-10.6-4.7-10.6-11.4c0-32-0.3-64.1,0.1-96.1c0.2-14,6.5-25.5,17.6-34.3c9-7.2,19.2-10.1,30.7-10C130,71.8,168.3,71.7,206.5,71.7z"/><path d="M323.9,120.6c7.6-3.1,14.4-5.6,20.9-8.5c9.4-4.2,18.4-9,26.3-15.8c10-8.7,16.8-19.7,22-31.6c4.3-9.7,7.9-19.7,12-30.2c7.8,19.3,16,38,31.4,52.4c15.4,14.4,34.6,21.7,54.8,28.4c-19.7,7.8-38.7,15.8-53.1,31.3c-14.4,15.5-21.1,35-28,55.1c-7.4-20.1-15.5-39-31-53.4C363.8,133.9,344.5,127,323.9,120.6z M378.6,118.8c11.9,7.4,21.7,16.6,29.9,28c7.4-12.1,16.7-21.7,28-29.9c-12.1-7.4-21.7-16.6-29.8-27.9C399.5,100.8,390.3,110.6,378.6,118.8z"/></g><g id ="check"><path class="st0" d="M155.9,368.2c0,8.1-2.9,15-8.6,20.8c-5.7,5.7-12.7,8.6-20.8,8.6c-8.1,0-15-2.9-20.8-8.6\tc-5.7-5.7-8.6-12.7-8.6-20.8c0-5.5,1.5-10.8,4.6-15.8c0.1-0.1,1.3-1.9,3.6-5.2c2.2-3.3,4.2-6.2,5.9-8.7c1.7-2.5,3.6-5.9,5.7-10.1\tc2.1-4.2,3.8-8.1,4.8-11.6c0.6-2.4,2.2-3.7,4.8-3.7c2.6,0,4.2,1.2,4.8,3.7c1.1,3.5,2.7,7.4,4.8,11.6c2.1,4.2,4.1,7.6,5.7,10.1\tc1.7,2.5,3.6,5.4,5.9,8.7c2.2,3.3,3.4,5,3.6,5.2C154.3,357.4,155.9,362.7,155.9,368.2 M273.5,338.8c0-22.7-6.2-43.7-18.6-63.2\tc-0.9-1.4-5.7-8.3-14.4-20.8c-8.7-12.5-16.4-24-23.2-34.7c-6.8-10.6-14.4-24.3-22.9-40.9c-8.4-16.6-14.8-32-19.1-46.3\tc-1.2-4.6-3.8-8.2-7.7-10.8c-3.9-2.6-7.8-3.9-11.8-3.9c-4,0-7.9,1.3-11.7,3.9c-3.8,2.6-6.4,6.2-7.8,10.8\tc-4.3,14.2-10.6,29.7-19.1,46.3c-8.4,16.6-16,30.2-22.9,40.9c-6.8,10.6-14.5,22.2-23.2,34.7c-8.7,12.5-13.4,19.4-14.4,20.8\tc-12.4,19.9-18.6,41-18.6,63.2c0,32.5,11.5,60.2,34.4,83.1c23,23,50.7,34.5,83.2,34.5c32.5,0,60.2-11.5,83.1-34.5\tC262,399,273.5,371.3,273.5,338.8 M431.7,151.5c1.7-1.7,2.6-3.7,2.6-6.1c0-2.3-0.9-4.4-2.6-6.1l-13.8-13.8c-1.7-1.7-3.7-2.6-6.1-2.6\ts-4.4,0.9-6.1,2.6l-37.2,37.2l-19.9-19.9c-1.7-1.7-3.7-2.6-6.1-2.6s-4.4,0.9-6.1,2.6l-13.8,13.8c-1.7,1.7-2.6,3.7-2.6,6.1\tc0,2.3,0.9,4.4,2.6,6.1l39.7,39.7c1.7,1.7,3.7,2.6,6.1,2.6c2.3,0,4.4-0.9,6.1-2.6L431.7,151.5z M450.7,162.8\tc0,13.3-3.3,25.6-9.9,36.9c-6.6,11.3-15.5,20.2-26.8,26.8c-11.3,6.6-23.6,9.9-36.9,9.9c-13.3,0-25.6-3.3-36.9-9.9\tc-11.3-6.6-20.2-15.5-26.8-26.8c-6.6-11.3-9.9-23.6-9.9-36.9c0-13.3,3.3-25.6,9.9-36.9c6.6-11.3,15.5-20.2,26.8-26.8\tc11.3-6.6,23.6-9.9,36.9-9.9c13.3,0,25.6,3.3,36.9,9.9c11.3,6.6,20.2,15.5,26.8,26.8C447.4,137.1,450.7,149.4,450.7,162.8 M481,162.8c0-18.8-4.6-36.2-13.9-52.1c-9.3-15.9-21.9-28.5-37.8-37.8C413.4,63.6,396.1,59,377.2,59c-18.8,0-36.2,4.6-52.1,13.9\tc-15.9,9.3-28.5,21.9-37.8,37.8c-9.3,15.9-13.9,33.3-13.9,52.1c0,18.8,4.6,36.2,13.9,52.1c9.3,15.9,21.9,28.5,37.8,37.8\tc15.9,9.3,33.3,13.9,52.1,13.9c18.8,0,36.2-4.6,52.1-13.9c15.9-9.3,28.5-21.9,37.8-37.8C476.4,199,481,181.6,481,162.8"/></g><g id="ritirato"><path d="M253.3,424.6c3.7,0,7.3-0.9,10.7-2.8L395.5,349c7-3.9,11.4-11.3,11.4-19.3V184.9c0-8-4.4-15.4-11.4-19.3L264,92.7 c-6.7-3.7-14.7-3.7-21.4,0c0,0,0,0,0,0l-131.5,72.9c-7,3.9-11.4,11.3-11.4,19.3v144.8c0,8,4.4,15.4,11.4,19.3l131.5,72.9 C245.9,423.7,249.6,424.6,253.3,424.6z M388.8,329.7c0,1.4-0.8,2.8-2.1,3.5l-124.4,68.9V264.5l126.5-70.1V329.7z M380.9,178.2 l-127.6,70.7l-53.9-30.6l126.9-70.3L380.9,178.2z M251.3,108.5c1.2-0.7,2.7-0.7,3.9,0l52.5,29.1l-126.6,70.2l-53.7-30.6 L251.3,108.5z M117.8,329.7V192.6l58.7,33.4c0,0,0,0,0,0l67.7,38.5v137.6l-124.4-68.9C118.6,332.5,117.8,331.1,117.8,329.7z"/><path d="M194.5,302v-38.2c0-3.3-1.8-6.3-4.7-7.9L142,229.5c-2.8-1.5-6.2-1.5-9,0.1c-2.8,1.6-4.4,4.6-4.4,7.8v38.2 c0,3.3,1.8,6.3,4.7,7.9l47.9,26.4c1.4,0.7,2.9,1.1,4.4,1.1c1.6,0,3.2-0.4,4.6-1.3C192.9,308.1,194.5,305.2,194.5,302z M176.5,286.7l-29.8-16.4v-17.6l29.8,16.4V286.7z"/><path d="M227.6,351.4l-23.9-13.2c-4.4-2.4-9.9-0.8-12.3,3.6c-2.4,4.4-0.8,9.9,3.6,12.3l23.9,13.2c1.4,0.8,2.9,1.1,4.3,1.1 c3.2,0,6.3-1.7,7.9-4.7C233.5,359.3,231.9,353.8,227.6,351.4z"/><path d="M442.3,124.1l16.7-16.7c2.6-2.6,3.4-6.5,2-9.8c-1.4-3.4-4.7-5.6-8.3-5.6h-44.9c-5,0-9,4-9,9v44.9c0,3.7,2.2,6.9,5.6,8.3 c1.1,0.5,2.3,0.7,3.5,0.7c2.4,0,4.7-0.9,6.4-2.6l15.2-15.2c57.2,83.7,47,198.6-25.3,271c-62.2,62.2-154.6,79.9-235.3,45 c-4.6-2-9.9,0.1-11.9,4.7c-2,4.6,0.1,9.9,4.7,11.9c29.1,12.6,60.2,18.9,91.5,18.9c13.9,0,28-1.3,41.9-3.8 c46.3-8.4,88.4-30.6,121.8-64c39.5-39.5,63.4-92,67.2-147.7C487.6,219.9,472.8,167.2,442.3,124.1z"/><path d="M102.3,360.3c-3.4-1.4-7.3-0.6-9.8,2l-15.2,15.2c-57.2-83.7-47-198.6,25.3-271c62-62,154.2-79.8,234.8-45.2 c4.6,2,9.9-0.2,11.9-4.7c2-4.6-0.2-9.9-4.7-11.9c-42-18-88.1-23.2-133.2-14.9c-46.2,8.5-88.2,30.6-121.6,63.9 c-39.5,39.5-63.4,92-67.2,147.7c-3.6,53.1,11.2,105.8,41.7,149l-16.7,16.7c-2.6,2.6-3.4,6.5-2,9.8c1.4,3.4,4.7,5.6,8.3,5.6h44.9 c5,0,9-4,9-9v-44.9C107.8,365,105.6,361.7,102.3,360.3z"/></g><g id="accettazione"><rect x="410.1" y="306.6" class="st0" width="22.9" height="9.7"/><path class="st0" d="M441.5,394.5c-2.1,0-4.1,0.3-6.2,1c-10,3.4-15.4,14.3-12,24.3c3.4,10,14.3,15.4,24.3,12 c10-3.4,15.4-14.3,12-24.3C456.9,399.5,449.4,394.5,441.5,394.5z"/><path class="st0" d="M213.8,395.5c-2-0.7-4.1-1-6.2-1c-8,0-15.4,5-18.1,13c-3.4,10,2,20.9,12,24.3c10,3.4,20.9-2,24.3-12 C229.2,409.8,223.8,398.9,213.8,395.5z"/><rect x="220" y="306.6" class="st0" width="22.9" height="9.7"/><rect x="220" y="214.8" class="st0" width="22.9" height="9.7"/><path class="st0" d="M485.4,87.9H164.8c-0.5,0-0.9,0.4-0.9,0.9v296.6c0,0.5,0.4,0.9,0.9,0.9h320.5c0.5,0,0.9-0.4,0.9-0.9V88.9 C486.3,88.3,485.9,87.9,485.4,87.9z M287.5,105.8c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4v8.9c0,0.2-0.2,0.4-0.4,0.4 h-77.3c-0.2,0-0.4-0.2-0.4-0.4V105.8z M287.5,194.3c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4v8.9c0,0.2-0.2,0.4-0.4,0.4 h-77.3c-0.2,0-0.4-0.2-0.4-0.4V194.3z M270.5,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M270.5,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M270.5,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M270.5,203.3c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V203.3z M270.5,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M270.5,114.8c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V114.8z M365.5,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M365.5,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M365.5,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M365.5,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M460.6,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M460.6,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M460.6,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M460.6,203.3c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V203.3z M460.6,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M460.6,114.8c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V114.8z"/><rect x="315.1" y="127.9" class="st0" width="22.9" height="9.7"/><rect x="315.1" y="214.8" class="st0" width="22.9" height="9.7"/><rect x="410.1" y="127.9" class="st0" width="22.9" height="9.7"/><rect x="410.1" y="214.8" class="st0" width="22.9" height="9.7"/><rect x="315.1" y="306.6" class="st0" width="22.9" height="9.7"/><rect x="220" y="127.9" class="st0" width="22.9" height="9.7"/><path class="st0" d="M92.9,182c-2-2-4.4-3-7.2-3c-2.7,0-5.1,1-7.1,3l-5.9,5.9c-2,1.9-3,4.2-3,7.1c0,2.8,1,5.2,3,7.1l23,23.1H40.4 c-2.7,0-4.9,1-6.6,3c-1.7,2-2.6,4.3-2.6,7.1v10.1c0,2.8,0.9,5.2,2.6,7.1c1.7,2,3.9,3,6.6,3h55.4l-23,23c-2,2-3,4.4-3,7.2 c0,2.8,1,5.2,3,7.2l5.9,5.9c2,1.9,4.4,2.9,7.1,2.9c2.7,0,5.1-1,7.2-2.9l51.2-51.2c1.9-1.9,2.9-4.3,2.9-7.2c0-2.9-1-5.2-2.9-7.1 L92.9,182z"/></g><g id="reception"><path d="m474 294c-6 0-12 5-12 12l0 45c0 26-21 48-47 48l-325 0c-27 0-48-22-48-48l0-45c0-7-5-12-12-12-6 0-12 5-12 12l0 45c0 40 32 72 72 72l325 0c39 0 71-32 71-72l0-45c0-7-5-12-12-12m0 0c-6 0-12 5-12 12l0 45c0 26-21 48-47 48l-325 0c-27 0-48-22-48-48l0-45c0-7-5-12-12-12-6 0-12 5-12 12l0 45c0 40 32 72 72 72l325 0c39 0 71-32 71-72l0-45c0-7-5-12-12-12z m-372 58l300 0c7 0 12-5 12-12 0-6-5-12-12-12l-300 0c-6 0-11 6-11 12 0 7 5 12 11 12m0 0l300 0c7 0 12-5 12-12 0-6-5-12-12-12l-300 0c-6 0-11 6-11 12 0 7 5 12 11 12z m251-82l-251 0c-6 0-11 5-11 12 0 6 5 12 11 12l251 0c7 0 12-6 12-12 0-7-5-12-12-12m0 0l-251 0c-6 0-11 5-11 12 0 6 5 12 11 12l251 0c7 0 12-6 12-12 0-7-5-12-12-12z m61 12c0-7-5-12-12-12-7 0-12 5-12 12 0 6 5 12 12 12 7 0 12-6 12-12m0 0c0-7-5-12-12-12-7 0-12 5-12 12 0 6 5 12 12 12 7 0 12-6 12-12z m-312-47l300 0c7 0 12-5 12-12 0-6-5-12-12-12l-300 0c-6 0-11 6-11 12 0 7 5 12 11 12m0 0l300 0c7 0 12-5 12-12 0-6-5-12-12-12l-300 0c-6 0-11 6-11 12 0 7 5 12 11 12z m222-170l-7-7c-1-1-3-2-4-2-1 0-2 1-3 2l-58 57-57-57c-1-1-2-2-4-2-1 0-2 1-3 2l-7 7c-1 1-2 2-2 3 0 2 1 3 2 4l68 68c1 1 2 1 3 1 1 0 3 0 4-1l68-68c1-1 1-2 1-4 0-1 0-2-1-3m0 0l-7-7c-1-1-3-2-4-2-1 0-2 1-3 2l-58 57-57-57c-1-1-2-2-4-2-1 0-2 1-3 2l-7 7c-1 1-2 2-2 3 0 2 1 3 2 4l68 68c1 1 2 1 3 1 1 0 3 0 4-1l68-68c1-1 1-2 1-4 0-1 0-2-1-3z"/></g><g id="shipment"><rect x="270.1" y="306.6" class="st0" width="22.9" height="9.7"/><path class="st0" d="M301.5,394.5c-2.1,0-4.1,0.3-6.2,1c-10,3.4-15.4,14.3-12,24.3c3.4,10,14.3,15.4,24.3,12\tc10-3.4,15.4-14.3,12-24.3C316.9,399.5,309.4,394.5,301.5,394.5z"/><path class="st0" d="M73.8,395.5c-2-0.7-4.1-1-6.2-1c-8,0-15.4,5-18.1,13c-3.4,10,2,20.9,12,24.3c10,3.4,20.9-2,24.3-12\tC89.2,409.8,83.8,398.9,73.8,395.5z"/><rect x="80" y="306.6" class="st0" width="22.9" height="9.7"/><rect x="80" y="214.8" class="st0" width="22.9" height="9.7"/><path class="st0" d="M345.4,87.9H24.8c-0.5,0-0.9,0.4-0.9,0.9v296.6c0,0.5,0.4,0.9,0.9,0.9h320.5c0.5,0,0.9-0.4,0.9-0.9V88.9\tC346.3,88.3,345.9,87.9,345.4,87.9z M147.5,105.8c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4v8.9c0,0.2-0.2,0.4-0.4,0.4\th-77.3c-0.2,0-0.4-0.2-0.4-0.4V105.8z M147.5,194.3c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4v8.9c0,0.2-0.2,0.4-0.4,0.4\th-77.3c-0.2,0-0.4-0.2-0.4-0.4V194.3z M130.5,362.9c0,0.2-0.2,0.4-0.4,0.4H52.8c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M130.5,295c0,0.2-0.2,0.4-0.4,0.4H52.8c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M130.5,271.2c0,0.2-0.2,0.4-0.4,0.4H52.8c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M130.5,203.3c0,0.2-0.2,0.4-0.4,0.4H52.8c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V203.3z M130.5,182.7c0,0.2-0.2,0.4-0.4,0.4H52.8c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M130.5,114.8c0,0.2-0.2,0.4-0.4,0.4H52.8c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V114.8z M225.5,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M225.5,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M225.5,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M225.5,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M320.6,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M320.6,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M320.6,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M320.6,203.3c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V203.3z M320.6,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M320.6,114.8c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9\tc0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V114.8z"/><rect x="175.1" y="127.9" class="st0" width="22.9" height="9.7"/><rect x="175.1" y="214.8" class="st0" width="22.9" height="9.7"/><rect x="270.1" y="127.9" class="st0" width="22.9" height="9.7"/><rect x="270.1" y="214.8" class="st0" width="22.9" height="9.7"/><rect x="175.1" y="306.6" class="st0" width="22.9" height="9.7"/><rect x="80" y="127.9" class="st0" width="22.9" height="9.7"/><path class="st0" d="M485.1,233.2L433.9,182c-2-2-4.4-3-7.2-3c-2.7,0-5.1,1-7.1,3l-5.9,5.9c-2,1.9-3,4.2-3,7.1c0,2.8,1,5.2,3,7.1\tl23,23.1h-55.4c-2.7,0-4.9,1-6.6,3c-1.7,2-2.6,4.3-2.6,7.1v10.1c0,2.8,0.9,5.2,2.6,7.1c1.7,2,3.9,3,6.6,3h55.4l-23,23\tc-2,2-3,4.4-3,7.2c0,2.8,1,5.2,3,7.2l5.9,5.9c2,1.9,4.4,2.9,7.1,2.9c2.7,0,5.1-1,7.2-2.9l51.2-51.2c1.9-1.9,2.9-4.3,2.9-7.2\tC488,237.4,487,235,485.1,233.2z"/></g><g id="autoclave"><path class="st0" d="M355.7,162.7V71.6c0-0.4-0.3-0.6-0.6-0.6H181.8c-0.4,0-0.6,0.3-0.6,0.6v91.1c0,0.4,0.3,0.6,0.6,0.6H355C355.4,163.3,355.7,163,355.7,162.7 M355.7,266.7v-91.1c0-0.4-0.3-0.6-0.6-0.6H181.8c-0.4,0-0.6,0.3-0.6,0.6v91.1c0,0.4,0.3,0.6,0.6,0.6H355C355.4,267.3,355.7,267,355.7,266.7 M410.9,203c0,4.5,3.6,8.1,8.1,8.1c4.5,0,8.1-3.6,8.1-8.1s-3.6-8.1-8.1-8.1C414.5,195,410.9,198.6,410.9,203 M392.6,203c0,4.5,3.6,8.1,8.1,8.1c4.5,0,8.1-3.6,8.1-8.1s-3.6-8.1-8.1-8.1C396.2,195,392.6,198.6,392.6,203 M445,103.6v-32c0-0.4-0.3-0.6-0.6-0.6h-51.1c-0.4,0-0.6,0.3-0.6,0.6v32c0,0.4,0.3,0.6,0.6,0.6h51.1C444.7,104.2,445,103.9,445,103.6 M446,203c0-4.5-3.6-8.1-8.1-8.1c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1C442.3,211.1,446,207.5,446,203 M450.7,222.7c0,0.4-0.3,0.6-0.6,0.6h-61.3c-0.4,0-0.6-0.3-0.6-0.6V58.2c0-0.4,0.3-0.6,0.6-0.6h61.3c0.4,0,0.6,0.3,0.6,0.6V222.7z M369.2,280.5c0,0.4-0.3,0.6-0.6,0.6H169.9c-0.4,0-0.6-0.3-0.6-0.6V58.2c0-0.4,0.3-0.6,0.6-0.6h198.7c0.4,0,0.6,0.3,0.6,0.6V280.5z M472.4,569.5V26.8c0-0.4-0.3-0.6-0.6-0.6H148.6c-0.4,0-0.6,0.3-0.6,0.6v542.7c0,0.4,0.3,0.6,0.6,0.6h323.1C472.1,570.2,472.4,569.9,472.4,569.5"/></g><g id="dirty-ferri"><rect x="410.1" y="306.6" class="st0" width="22.9" height="9.7"/><path class="st0" d="M441.5,394.5c-2.1,0-4.1,0.3-6.2,1c-10,3.4-15.4,14.3-12,24.3c3.4,10,14.3,15.4,24.3,12 c10-3.4,15.4-14.3,12-24.3C456.9,399.5,449.4,394.5,441.5,394.5z"/><path class="st0" d="M213.8,395.5c-2-0.7-4.1-1-6.2-1c-8,0-15.4,5-18.1,13c-3.4,10,2,20.9,12,24.3c10,3.4,20.9-2,24.3-12 C229.2,409.8,223.8,398.9,213.8,395.5z"/><rect x="220" y="306.6" class="st0" width="22.9" height="9.7"/><rect x="220" y="214.8" class="st0" width="22.9" height="9.7"/><path class="st0" d="M485.4,87.9H164.8c-0.5,0-0.9,0.4-0.9,0.9v296.6c0,0.5,0.4,0.9,0.9,0.9h320.5c0.5,0,0.9-0.4,0.9-0.9V88.9 C486.3,88.3,485.9,87.9,485.4,87.9z M287.5,105.8c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4v8.9c0,0.2-0.2,0.4-0.4,0.4 h-77.3c-0.2,0-0.4-0.2-0.4-0.4V105.8z M287.5,194.3c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4v8.9c0,0.2-0.2,0.4-0.4,0.4 h-77.3c-0.2,0-0.4-0.2-0.4-0.4V194.3z M270.5,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M270.5,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M270.5,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M270.5,203.3c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V203.3z M270.5,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M270.5,114.8c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V114.8z M365.5,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M365.5,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M365.5,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M365.5,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M460.6,362.9c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V362.9z M460.6,295c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V295z M460.6,271.2c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V271.2z M460.6,203.3c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V203.3z M460.6,182.7c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-63.4 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V182.7z M460.6,114.8c0,0.2-0.2,0.4-0.4,0.4h-77.3c-0.2,0-0.4-0.2-0.4-0.4v-8.9 c0-0.2,0.2-0.4,0.4-0.4h77.3c0.2,0,0.4,0.2,0.4,0.4V114.8z"/><rect x="315.1" y="127.9" class="st0" width="22.9" height="9.7"/><rect x="315.1" y="214.8" class="st0" width="22.9" height="9.7"/><rect x="410.1" y="127.9" class="st0" width="22.9" height="9.7"/><rect x="410.1" y="214.8" class="st0" width="22.9" height="9.7"/><rect x="315.1" y="306.6" class="st0" width="22.9" height="9.7"/><rect x="220" y="127.9" class="st0" width="22.9" height="9.7"/><path class="st0" d="M92.9,182c-2-2-4.4-3-7.2-3c-2.7,0-5.1,1-7.1,3l-5.9,5.9c-2,1.9-3,4.2-3,7.1c0,2.8,1,5.2,3,7.1l23,23.1H40.4 c-2.7,0-4.9,1-6.6,3c-1.7,2-2.6,4.3-2.6,7.1v10.1c0,2.8,0.9,5.2,2.6,7.1c1.7,2,3.9,3,6.6,3h55.4l-23,23c-2,2-3,4.4-3,7.2 c0,2.8,1,5.2,3,7.2l5.9,5.9c2,1.9,4.4,2.9,7.1,2.9c2.7,0,5.1-1,7.2-2.9l51.2-51.2c1.9-1.9,2.9-4.3,2.9-7.2c0-2.9-1-5.2-2.9-7.1 L92.9,182z"/></g><g id="sterilization"><path d="m370 413c-20 30-51 51-87 58-36 7-73-1-103-21-30-21-51-52-58-88-7-36 1-72 21-102 21-31 52-51 88-58 32-7 66-1 95 16l-77 113c-3 4-2 10 3 13 2 1 4 2 6 1 3 0 5-2 6-4l77-113c26 20 44 49 50 82 7 36 0 72-21 103m-143-229c-41 8-76 31-99 65-23 35-32 76-24 117 8 40 32 76 66 99 34 23 76 31 116 23 41-7 76-31 99-65 24-34 32-76 24-117-8-40-31-75-65-99-35-23-76-31-117-23m30-85c5 0 9-4 9-9l0-55c0-5-4-9-9-9-5 0-9 4-9 9l0 55c0 5 4 9 9 9m66 8c1 1 1 1 2 1 4 0 8-3 9-7l14-53c2-5-1-10-6-11-5-1-10 1-11 6l-15 53c-1 5 2 10 7 11m-144-6c1 4 5 7 9 7 1 0 2 0 3-1 4-1 7-6 6-11l-14-53c-1-5-7-7-11-6-5 1-8 6-7 11z m242-31c-4-3-10-1-12 3l-28 48c-2 4-1 9 4 12 1 1 3 1 4 1 3 0 6-1 8-4l27-48c3-4 1-10-3-12m-297 64c2 0 3 0 5-1 4-3 6-8 3-12l-27-48c-3-4-8-6-13-3-4 2-6 8-3 12l27 48c2 3 5 4 8 4"/></g><g id="storage"><path d="m224 186c0-4-3-8-8-8l-45 0c-4 0-8 4-8 8 0 5 4 9 8 9l45 0c5 0 8-4 8-9m0 27c0-4-3-8-8-8l-45 0c-4 0-8 4-8 8 0 5 4 8 8 8l45 0c5 0 8-3 8-8m0 171c0-4-3-8-8-8l-45 0c-4 0-8 4-8 8 0 5 4 8 8 8l45 0c5 0 8-3 8-8m0 27c0-4-3-8-8-8l-45 0c-4 0-8 4-8 8 0 5 4 8 8 8l45 0c5 0 8-3 8-8m175 4c0 5 3 9 8 9l45 0c4 0 7-4 7-9 0-4-3-8-7-8l-45 0c-5 0-8 4-8 8m91 24l-127 0 0-46 127 0z m0-62l-127 0 0-17 127 0z m-68-33l-61 0c-8 0-14 6-14 14l0 81-89 0c-1 0-1-1-1-2l0-295c0-1 0-1 1-1l46 0 0 92c0 3 2 6 5 7 2 1 6 1 8-1l22-18 23 18c1 1 3 2 4 2 2 0 3 0 4-1 3-1 4-4 4-7l0-92 46 0c1 0 2 0 2 1l0 202z m-63-128l-15-12c-1-1-3-1-5-1-1 0-3 0-5 1l-14 12 0-75 39 0 0 75z m-118 218c0 2-2 5-4 5l-207 0c-3 0-5-3-5-5l0-121 0 0 0-54c0-2 2-4 5-4l68 0 0 92c0 3 2 6 5 7 2 1 6 1 8-1l22-18 23 18c1 1 3 2 4 2 2 0 3-1 4-1 2-1 4-4 4-7l0-92 69 0c2 0 4 2 4 5l0 174z m-88-179l0 75-15-12c-1-1-3-1-5-1-2 0-3 0-5 1l-14 12 0-75z m88-21c0 2-2 5-4 5l-207 0c-3 0-5-2-5-5l0-21 0 0 0-153c0-3 2-5 5-5l68 0 0 92c0 3 2 6 5 7 2 1 5 1 8-1l22-18 22 18c2 1 4 2 5 2 1 0 3 0 4-1 2-1 4-4 4-7l0-92 68 0c3 0 5 2 5 5z m-88-104l-15-12c-1-1-3-1-5-1-2 0-3 0-5 1l-14 12 0-75 39 0z m353 311l0-83c0-8-6-14-14-14l-55 0 0-202c0-9-7-17-17-17l-162 0c0 0-1 0-1 0l0-65c0-4-1-8-3-11l-1 0c-3-6-9-10-17-10l-206 0c-11 0-21 9-21 21l0 374c0 11 10 21 21 21l331 0c0 0 0 0 0 0l131 0c8 0 14-7 14-14"/></g><g id="drop"><path d="m263 418c0 6 5 10 10 10 53 0 96-41 96-92 0-5-5-9-10-9-6 0-10 4-10 9 0 40-34 73-76 73-5 0-10 4-10 9m207-327l-20 0 0-19c0-5-4-10-10-10-5 0-10 5-10 10l0 19-19 0c-6 0-10 4-10 10 0 5 4 9 10 9l19 0 0 19c0 5 5 10 10 10 6 0 10-5 10-10l0-19 20 0c5 0 10-4 10-9 0-6-5-10-10-10m-362 290l-19 0 0-18c0-6-5-10-10-10-6 0-10 4-10 10l0 18-19 0c-6 0-10 5-10 10 0 5 4 10 10 10l19 0 0 18c0 6 4 10 10 10 5 0 10-4 10-10l0-18 19 0c6 0 10-5 10-10 0-5-4-10-10-10m165 73c-67 0-121-53-121-118 0-73 93-215 121-257 29 42 122 184 122 257 0 65-54 118-122 118m0-402c-3 0-6 1-8 4-5 8-133 189-133 280 0 76 63 137 141 137 79 0 142-61 142-137 0-91-128-272-133-280-2-3-5-4-9-4"/></g><g id="ferri"><path d="M237.6,231.5c12.3-52.2,24.8-104.3,36.9-156.5c2.7-11.6,1.6-23.4-4.1-34.3c-4-7.6-10-13-17.9-17.1c-0.6,2.4-1.1,4-1.5,5.6c-11.6,48-23.3,96.1-34.8,144.2c-0.9,3.7-2.6,5.8-6.2,7.2c-13.5,5.4-26.8,11.1-40.3,16.5c-4.1,1.6-6.3,4-7.7,8.2c-17.2,52.5-34.7,105-52.1,157.5c-2.1,6.4-3,6.7-8.7,3.3c-11.9-7.2-24.8-10-38.7-7.8c-27,4.3-47.4,28.6-46.7,55.7c0.7,28.4,22.1,51.3,50.5,54.3c27.1,2.9,52.8-15.5,59.4-42.1c2.3-9.1,5.4-18,8-27.1c0.8-3,2.5-3.7,5.3-3.7c6.6,0.2,13.3,0.1,19.9,0c5.8,0,9.1-2.6,9-7c-0.1-4.2-3.2-6.6-8.8-6.6c-6.2,0-12.3,0-19.1,0c0.4-1.7,0.5-2.6,0.8-3.5c13.7-39.9,27.4-79.8,41.3-119.6c0.8-2.2,3.3-4.5,5.5-5.4c14.9-5.9,30-11.4,45.1-17C235.3,235.5,236.9,234.4,237.6,231.5z M71.7,446.3c-15.3,0.1-34-12.6-33.4-33.2c0.5-18.4,15-33.3,33.5-33.2c19.4,0.1,33,14.9,33.2,33.1C105,431.2,90,446.2,71.7,446.3z M200.3,230.9c-7.4,0-13.5-6.1-13.7-13.5c-0.2-7.6,6-13.9,13.6-13.9c7.7-0.1,13.9,6,13.9,13.7C214.1,224.8,207.9,230.9,200.3,230.9z"/><path d="M297.1,366.1c-5.5,3.4-6.5,3.1-8.5-3c-12.3-37.1-24.5-74.2-36.8-111.3c-1.8-5.4-3.7-10.7-5.2-14.9c-5.8,2.7-11.2,5.3-16.7,7.7c-3.5,1.5-7.2,2.8-10.8,4.1c-5.9,2.2-5.9,2.2-3.9,8c11.1,32.1,22.3,64.2,33.4,96.3c3.2,9.3,6.3,18.7,9.8,29c-6.7,0-12.4-0.1-18.1,0c-5.3,0.1-8.1,2.5-8.1,6.8c0,4.3,2.9,6.8,8.1,6.8c6.5,0.1,13-0.2,19.5,0.2c1.5,0.1,3.8,1.5,4.2,2.9c2.9,8.6,6,17.2,8,26.1c6.8,30.6,37.5,49.9,68.2,42.2c29.4-7.4,48.6-36.7,40.1-68.4C371,362.3,329.5,346.5,297.1,366.1z M326.7,446.2c-18.2,0-33-14.8-33.1-33c-0.1-18.4,14.8-33.3,33.3-33.4c18.8,0.5,32.7,13.3,33.6,32.7C361.3,430.5,346.1,446.2,326.7,446.2z"/><path d="M152.8,196.7c0.4,1.5,0.8,3,1.2,4.5c3.2-7,9.3-8.9,15.3-11.2c4-1.5,7.9-3.5,12-4.9c3.3-1.1,4.1-2.6,3.2-6.1c-5.6-22.2-11-44.4-16.4-66.6c-4.3-17.5-8.6-35-12.9-52.5c-2.9-12-5.9-23.9-9-36.5c-9.4,5-15.9,11.5-19.6,20.6c-4.5,10.8-4.7,22-2.1,33.2C133.8,117.1,143.3,156.9,152.8,196.7z"/><path d="M451,345.2c2.6-1.9,3.6-3.9,3.6-7.1c-0.1-50.8-0.1-101.6-0.1-152.4c0-1.6-0.2-3.2-0.3-4.8c-15,0-29.5,0-44.2,0c0,65.6,0,130.5,0,196.3c7.2-5.9,13.7-11.5,20.5-16.8C437.3,355,444.2,350,451,345.2z"/><path d="M440.3,164.1c-0.6-11.4,0.1-22.5,5.2-33.1c0.9-1.9,1.4-4,1.7-6.1c2.7-18.6,3.2-37.3,0-55.9c-1.7-10-4.6-19.7-10.8-28.1c-5.1-6.9-11.8-11-20.7-11.9c0,48.5,0,96.6,0,144.6c8.3,0,16.2,0,24.7,0C440.3,170.4,440.5,167.2,440.3,164.1z"/><path d="M452.7,398.4c-13.6,10.7-27.3,21.4-40.8,32.2c-1.1,0.9-1.9,2.7-2,4.2c-0.2,6.2-0.3,12.4,0,18.5c0.4,9.1,7.2,15.4,16.4,15.5c4.3,0.1,8.6,0.1,12.8,0c8-0.3,15.1-6.3,15.2-14.2c0.4-18.8,0.1-37.6,0.1-57C453.5,398.1,453,398.2,452.7,398.4z"/><path d="M420.7,376.9c-8.7,5.8-12.4,12.5-11.1,22.8c0.9,7.5,0.2,15.2,0.2,23.1c1.1-0.3,1.6-0.3,1.9-0.6c13.8-10.8,27.5-21.6,41.2-32.5c0.8-0.7,1.6-2,1.7-3c0.1-11.6,0.1-23.1,0.1-36C442.6,360.1,432.2,369.2,420.7,376.9z"/></g><g id="checklist"><path d="M380.2,119.4v11.7c0,19.4-15.8,35.1-35.1,35.1H181.2c-19.4,0-35.1-15.8-35.1-35.1v-11.7c-19.4,0-35.1,15.8-35.1,35.1v259.1 c0,19.4,15.8,35.1,35.1,35.1h234.1c19.4,0,35.1-15.8,35.1-35.1V154.5C415.3,135.2,399.6,119.4,380.2,119.4z M226.8,325.2L203.4,372 c-3.6,7.1-13.1,8.7-18.7,3l-23.4-23.4c-4.6-4.6-4.6-12,0-16.6c4.6-4.6,12-4.6,16.6,0l11.9,11.9l16.2-32.3c2.9-5.8,9.9-8.1,15.7-5.2 C227.4,312.4,229.7,319.4,226.8,325.2z M226.8,230l-23.4,46.8c-3.6,7.1-13.1,8.7-18.7,3l-23.4-23.4c-4.6-4.6-4.6-12,0-16.6 c4.6-4.6,12-4.6,16.6,0l11.9,11.9l16.2-32.3c2.9-5.8,9.9-8.1,15.7-5.2C227.4,217.2,229.7,224.2,226.8,230z M356.8,378.5h-93.6 c-6.5,0-11.7-5.2-11.7-11.7s5.2-11.7,11.7-11.7h93.6c6.5,0,11.7,5.2,11.7,11.7C368.5,373.2,363.3,378.5,356.8,378.5z M356.8,331.6 h-70.2c-6.5,0-11.7-5.2-11.7-11.7s5.2-11.7,11.7-11.7h70.2c6.5,0,11.7,5.2,11.7,11.7S363.3,331.6,356.8,331.6z M356.8,283.3h-93.6 c-6.5,0-11.7-5.2-11.7-11.7s5.2-11.7,11.7-11.7h93.6c6.5,0,11.7,5.2,11.7,11.7C368.5,278,363.3,283.3,356.8,283.3z M356.8,236.4 h-70.2c-6.5,0-11.7-5.2-11.7-11.7s5.2-11.7,11.7-11.7h70.2c6.5,0,11.7,5.2,11.7,11.7S363.3,236.4,356.8,236.4z"/><path d="M181.1,142.9H345c6.5,0,11.7-5.2,11.7-11.7v-11.7c0.1-13-10.4-23.5-23.3-23.5h-22.5l-1.4-6.9c-3.6-18-16.3-33.7-34.1-38.3 c-27.1-7.1-52.9,10.1-58.2,35.9l-1.9,9.4h-22.5c-12.9,0-23.4,10.5-23.4,23.4v11.7C169.4,137.7,174.6,142.9,181.1,142.9z M263.2,84.3c6.6,0,11.7,5.1,11.7,11.7s-5.2,11.7-11.7,11.7c-6.6,0-11.7-5.2-11.7-11.7C251.5,89.4,256.6,84.3,263.2,84.3z"/></g><g id="vehicles-registry"><path d="M384.5,229.5l-12.8,3.5c-1,0.3-2,0.4-3.1,0.4c-2.4,0-4.6-0.7-6.5-2.1c-2.8-2-4.6-5-4.9-8.4l-1.1-13.2 c-0.3-2.7,0.5-5.4,2-7.6l0.5-0.7h-45.5c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7h55.1l12.3-17.6h-67.4c-3.7,0-6.7-3-6.7-6.7 c0-3.7,3-6.7,6.7-6.7l76.9-0.2l28.8-41.4V84.9c0-5-3.9-9.1-8.9-9.1h-22.1v17.5c0,8.2-6.7,14.8-15,14.8h-44.4 c-8.3,0-14.8-6.5-14.8-14.8V75.9h-22.3c-5,0-9.1,4.1-9.1,9.1v156.2c0,5,4.1,9.3,9.1,9.3h118.5c5,0,8.9-4.3,8.9-9.3v-55.9L390.9,225 C389.4,227.2,387.1,228.8,384.5,229.5z M313.1,126.1h75.1c3.7,0,6.6,3,6.6,6.7s-3,6.7-6.6,6.7h-75.1c-3.7,0-6.7-3-6.7-6.7 S309.4,126.1,313.1,126.1z"/><path d="M328.6,99.3H373c3.4,0,6.1-2.7,6.1-6.1V67.7c0-3.4-2.7-6.1-6.1-6.1h-6.7c0-8.6-7-15.5-15.6-15.5c-8.6,0-15.6,6.9-15.6,15.5 h-6.5c-3.4,0-6.1,2.7-6.1,6.1v25.5C322.5,96.6,325.2,99.3,328.6,99.3z M350.6,54.7c3.8,0,6.9,3.1,7,6.9h-13.9 C343.7,57.8,346.8,54.7,350.6,54.7z"/><path d="M474.9,87.1c-0.2-1.1-0.9-2.1-1.8-2.8L462,76.6c-0.8-0.5-1.6-0.8-2.5-0.8c-1.4,0-2.7,0.6-3.5,1.8l-78.7,112.8l18.2,12.7 l78.7-112.8C474.9,89.4,475.1,88.3,474.9,87.1z"/><path d="M365,208.9l1.1,13.2c0.1,0.8,0.5,1.4,1.1,1.9c0.4,0.3,1,0.5,1.5,0.5c0.2,0,0.5,0,0.7-0.1l12.8-3.5c0.6-0.2,1.1-0.5,1.4-1 l4.8-6.9l-18.2-12.7l-4.8,6.9C365.1,207.7,364.9,208.3,365,208.9z"/><path d="M244.4,246.1c-52.8,0-105.6,0-158.4,0c-6.1,0-7.6,1.5-7.6,7.5c0,41.8,0,83.7,0,125.5c0,1.2,0,2.3,0,3.6 c58,0,115.5,0,173.5,0c0-1.4,0-2.5,0.1-3.6c0-41.8,0-83.7,0-125.5C252,247.6,250.5,246.1,244.4,246.1z"/><path d="M372.2,361.3c-4.8-3.5-10.3-4.8-16.2-4.9c-0.3-1.1-0.6-2.1-0.8-3.1c-4.4-17.8-8.8-35.7-13.2-53.5c-1.2-5.1-2.6-6.3-6.9-6.3 c-22.1,0-44.1,0-66.1,0c-4.7,0-6.5,1.8-6.5,6.6c0,44.7,0,89.4,0,134.1c0,4.7,1.9,6.5,6.6,6.5c5,0,9.9,0,14.7,0 c5.4,16.9,15.9,25.8,30.8,26.1c6.5,0.1,12.6-1.7,18-5.3c7.4-5,11.8-12.1,13.7-20.9c4,0,7.9,0.1,11.7,0 c13.9-0.4,25.2-11.6,25.4-25.5c0.2-11,0.2-21.9,0-32.9C383.2,373.5,379.3,366.5,372.2,361.3z M284.8,367.1 c-4.7-0.1-6.6-1.9-6.6-6.6c0-13.2,0-26.5,0-39.7c0-4.3,1.9-6.3,6.2-6.3c11.5,0,23,0.1,34.5,0c3.5-0.1,5.5,1.5,6.3,4.9 c3.3,13.3,6.7,26.6,10,40c1.2,4.9-1,7.6-6.1,7.6c-7.4,0-14.9,0-22.3,0C299.5,367,292.1,367.1,284.8,367.1z M315.1,456.5 c-11.7-0.1-21.1-9.4-21.1-21.1c0-11.6,9.5-21,21.1-21c11.6,0.1,20.9,9.5,20.9,21.2C336,447.1,326.5,456.5,315.1,456.5z"/><path d="M78.5,393.5c0,7.4-0.1,14.5,0,21.6c0.2,11.3,7.8,21.1,18.7,24.3c2.6,0.8,5.3,1.1,8,1.6c3.7,16.5,16.8,25.5,30.7,25.8 c14.9,0.4,26-8.7,31.7-26.1c1.2,0,2.5,0,3.9,0c24.5,0,49.1,0,73.6,0c5.1,0,6.9-1.8,6.9-6.9c0-12.5,0-25,0-37.5c0-1-0.1-1.9-0.2-2.8 C193.9,393.5,136.3,393.5,78.5,393.5z M136.4,456.5c-11.7,0-21.2-9.4-21.2-21c0-11.7,9.5-21.1,21.1-21.1c11.6,0,21,9.5,21,21.2 C157.2,447.1,147.9,456.5,136.4,456.5z"/><path d="M314.5,428.1c-4.1,0.1-7.6,3.6-7.5,7.7c0,4.2,3.6,7.6,7.8,7.5c4.1-0.1,7.4-3.6,7.4-7.6 C322.2,431.5,318.7,428.1,314.5,428.1z"/><path d="M136.1,427.6c-4.2,0.1-7.7,3.6-7.7,7.8c0,4.3,3.6,7.9,7.9,7.9c4.3,0,7.9-3.7,7.8-8C144,431,140.4,427.5,136.1,427.6z"/></g><g id="basket-registry"><path d="M208.8,250.5h118.5c5,0,8.9-4.3,8.9-9.3v-55.9L308.4,225c-1.5,2.2-3.8,3.8-6.4,4.5l-12.8,3.5c-1,0.3-2,0.4-3.1,0.4 c-2.4,0-4.6-0.7-6.5-2.1c-2.8-2-4.6-5-4.9-8.4l-1.1-13.2c-0.3-2.7,0.5-5.4,2-7.6l0.5-0.7h-45.5c-3.7,0-6.7-3-6.7-6.7 c0-3.7,3-6.7,6.7-6.7h55.1l12.3-17.6h-67.4c-3.7,0-6.7-3-6.7-6.7c0-3.7,3-6.7,6.7-6.7l76.9-0.2l28.8-41.4V84.9c0-5-3.9-9.1-8.9-9.1 h-22.1v17.5c0,8.2-6.7,14.8-15,14.8h-44.4c-8.3,0-14.8-6.5-14.8-14.8V75.9h-22.3c-5,0-9.1,4.1-9.1,9.1v156.2 C199.7,246.2,203.8,250.5,208.8,250.5z M230.6,126.1h75.1c3.7,0,6.6,3,6.6,6.7s-3,6.7-6.6,6.7h-75.1c-3.7,0-6.7-3-6.7-6.7 S226.9,126.1,230.6,126.1z"/><path d="M246.1,99.3h44.4c3.4,0,6.1-2.7,6.1-6.1V67.7c0-3.4-2.7-6.1-6.1-6.1h-6.7c0-8.6-7-15.5-15.6-15.5 c-8.6,0-15.6,6.9-15.6,15.5h-6.5c-3.4,0-6.1,2.7-6.1,6.1v25.5C240,96.6,242.7,99.3,246.1,99.3z M268.1,54.7c3.8,0,6.9,3.1,7,6.9 h-13.9C261.2,57.8,264.3,54.7,268.1,54.7z"/><path d="M313,203.1l78.7-112.8c0.7-0.9,0.9-2,0.7-3.2c-0.2-1.1-0.9-2.1-1.8-2.8l-11.1-7.7c-0.8-0.5-1.6-0.8-2.5-0.8 c-1.4,0-2.7,0.6-3.5,1.8l-78.7,112.8L313,203.1z"/><path d="M282.9,207.2c-0.3,0.5-0.5,1.1-0.4,1.7l1.1,13.2c0.1,0.8,0.5,1.4,1.1,1.9c0.4,0.3,1,0.5,1.5,0.5c0.2,0,0.5,0,0.7-0.1 l12.8-3.5c0.6-0.2,1.1-0.5,1.4-1l4.8-6.9l-18.2-12.7L282.9,207.2z"/><path d="M244.1,424.2c0.1,0,0.3,0,0.4,0c4.7-0.2,8.3-4.2,8.1-8.9l-2.3-45.3c-0.2-4.7-4.2-8.3-8.9-8.1s-8.3,4.2-8.1,8.9l2.3,45.3 C235.9,420.6,239.6,424.2,244.1,424.2z"/><path d="M283.4,424.2c0.1,0,0.3,0,0.4,0c4.5,0,8.3-3.5,8.5-8.1l2.3-45.3c0.2-4.7-3.4-8.7-8.1-8.9c-4.7-0.2-8.7,3.4-8.9,8.1 l-2.3,45.3C275.1,419.9,278.7,423.9,283.4,424.2z"/><path d="M196,416.9c0.6,4.2,4.3,7.2,8.4,7.2c0.4,0,0.8,0,1.3-0.1c4.6-0.7,7.8-5,7.1-9.7L206,369c-0.7-4.6-5-7.8-9.7-7.1 c-4.6,0.7-7.8,5-7.1,9.7L196,416.9z"/><path d="M322.2,424.1c0.4,0.1,0.9,0.1,1.3,0.1c4.1,0,7.8-3,8.4-7.2l6.8-45.3c0.7-4.6-2.5-9-7.1-9.7c-4.6-0.7-9,2.5-9.7,7.1 l-6.8,45.3C314.4,419.1,317.6,423.4,322.2,424.1z"/><path d="M383.5,293.8h-3.7h-18.7H166.8h-18.7h-3.7c-14.1,0-25.5,11.4-25.5,25.5c0,11.9,8.2,21.9,19.2,24.7l21.6,86.2 c4.1,16.4,18.8,27.9,35.7,27.9h137.1c16.9,0,31.6-11.5,35.7-27.9l21.6-86.2c11-2.8,19.2-12.8,19.2-24.7 C409,305.2,397.6,293.8,383.5,293.8z M351.7,426.2c-2.2,8.8-10.1,15-19.2,15H195.4c-9.1,0-17-6.2-19.2-15l-20.3-81.3h216.2 L351.7,426.2z M383.5,327.8H144.4c-4.7,0-8.5-3.8-8.5-8.5s3.8-8.5,8.5-8.5h239.1c4.7,0,8.5,3.8,8.5,8.5S388.2,327.8,383.5,327.8z" /></g><g id="shipping-to-customer-units"><path d="M307.3,191.7c12.8,25.3,28.7,48.5,45.2,71.5c3.3,4.5,6.7,8.9,10,13.5c0.7-0.8,1.1-1.4,1.6-1.9c13.9-18.3,27-37.1,39-56.7 c9.1-15,17.8-30.3,24-46.9c3.6-9.4,5.6-19,4.6-29.2c-2.7-27.8-22.7-51.9-49.8-59.7c-4.5-1.2-9.3-1.9-13.9-2.8c-3.6,0-7.2,0-10.8,0 c-0.5,0.1-0.9,0.3-1.2,0.3c-25.3,3-43.9,15.9-55.4,38.5c-7.7,15-10,31-4.2,47.3C299.4,174.6,303.2,183.3,307.3,191.7z M362.8,126 c12.8,0,23.1,10.5,23,23.3c0,12.8-10.5,23.3-23.1,23.1c-12.6,0-23.1-10.5-23-23.3C339.6,136.4,350.1,125.9,362.8,126z"/><path d="M478.2,265.4c-0.8-5.8-3.2-10.8-6.5-15.5c-9.1-12.4-22-19.3-35.8-25.1c-3.8,7.1-7.7,14-11.2,20.3 c6.5,3.4,13.3,6.5,19.5,10.4c3.4,2.1,6.4,5.3,8.9,8.5c3,3.7,2.9,8,0.1,12c-1.5,2.1-3.3,4.2-5.3,5.9c-7,6.1-15.2,9.9-23.8,13.1 c-17.3,6.3-35.2,9.1-53.5,9.7c-23.1,0.8-45.8-1.6-67.9-9.3c-9.4-3.3-18.3-7.3-25.9-14c-8.9-7.9-9.1-15.4,0.1-22.8 c4.9-4,10.5-7,15.9-10.3c2.6-1.6,5.5-2.6,8.1-3.8c-3.8-7-7.7-13.9-11.5-20.8c-12.2,5.4-23.6,11.9-32.5,21.9 c-13,14.6-13.5,32.1-1.5,47.2c5.8,7.2,13.1,12.6,21.2,17c18.3,9.9,38,14.6,58.5,16.8c5.1,0.6,10.2,0.9,15.2,1.4 c6.9,0,13.9,0,20.8,0c3.4-0.3,6.9-0.6,10.3-0.9c21.6-1.9,42.6-6,62.4-15c8.8-4.1,16.9-9.1,23.7-16.3c5.5-5.9,9.4-12.8,10.5-20.9 c0-0.2,0.2-0.6,0.3-0.8c0-2.6,0-5.2,0-7.7C478.4,266.1,478.2,265.8,478.2,265.4z"/><path d="M248.3,400.9c-1.4-10.7-3.4-21.4-5.9-32c-1.8-7.8-4-15.6-10.5-21.1c-8.9-7.4-19.8-10.4-30.7-13.7c0,0.1,0,0.1,0,0.2 l-16.4-4.7c-3.1-0.9-6.2-1.7-9.1-2.6c-5.2,16.8-12.4,32.4-21.9,47.5c-4-11.5-4.4-21.5-1.6-29.5c-3.1-2.6-6.3-5.2-9.5-7.9 c-2.4,2.1-4.6,4.3-7.2,6.2c-2.2,1.5-1.6,2.8-1,4.9c0.8,2.5,1.3,5.2,1.3,8c0,2.5-0.8,5-1.4,7.4c-0.7,3.4-1.4,7-2.3,11.3 c-10.1-15.4-16.9-31.2-22-47.9l-22.6,5.8c-7.8,2.7-15,5.1-22,8c-10.1,4.1-17.2,11.1-20.5,21.9c-6.2,20.3-8.5,41-10.1,62 c-0.5,5.5-0.3,10.9-1.1,16.3c-0.9,6.4-0.1,11.7,6.2,15c68.5,0,137.1,0,205.6,0c5.9-2.2,7.1-6.7,6.5-12.4 C250.7,429.4,250,415.1,248.3,400.9z"/><path d="M96.5,272.7c2.3,0.6,3,1.7,3.8,3.6c4.7,10.8,10.4,21.1,19.3,29.2c16.6,15.3,35.3,12.4,49.7-3c7.2-7.8,12.4-16.9,16.3-26.8 c0.3-1,1.3-2.4,2.2-2.6c8.5-2.1,11.4-8.8,12.9-16.3c1.1-5.5-0.5-7.4-5.7-9c0.1-0.8,0.2-1.6,0.3-2.4c1.8-9.8,3.6-19.5,1.8-29.5 c-1.6-8.4-4.9-15.8-13.1-19.7c-3.3-1.6-5.5-3.6-6.8-7.2c-0.7-1.8-2.4-3.4-3.9-4.7c-7.3-5.7-16.1-6.8-24.7-6.7 c-13.1,0.3-25.6,3.4-36.9,10.5c-14.1,8.7-22.9,20.9-22.7,38c0.1,7.3,0.9,14.6,1.4,21.5c-1.5,1.1-4.1,1.9-4.7,3.5 C83.3,258.4,88.3,270.5,96.5,272.7z"/></g><g id="warehouse-sterile-client"><polygon points="421.2,93.5 390.4,93.5 390.4,117.3 365.6,117.3 365.6,93.5 334.8,93.5 334.8,171.3 421.2,171.3 "/><polygon points="390.4,292.3 365.6,292.3 365.6,266.5 334.8,266.5 334.8,342.3 421.2,342.3 421.2,266.5 390.4,266.5 "/><path d="M447.1,124.8V198l-141.2,1v-74.2H275v324.3h30.9v-44.8h141.2v44.8H478V124.8H447.1z M305.9,367.8V236.5h141.2l0,131.3 H305.9z"/><path d="M233.6,400.7c-1.2-9.4-3-18.8-5.2-28.1c-1.6-6.8-3.5-13.7-9.2-18.5c-7.8-6.5-17.4-9.1-26.9-12c0,0.1,0,0.1,0,0.2l-14.4-4.1 c-2.7-0.8-5.4-1.5-8-2.3c-4.6,14.7-10.9,28.4-19.2,41.7c-3.5-10.1-3.9-18.9-1.4-25.9c-2.7-2.3-5.5-4.6-8.3-6.9 c-2.1,1.8-4,3.8-6.3,5.4c-1.9,1.3-1.4,2.5-0.9,4.3c0.7,2.2,1.1,4.6,1.1,7c0,2.2-0.7,4.4-1.2,6.5c-0.6,3-1.2,6.1-2,9.9 c-8.9-13.5-14.8-27.4-19.3-42L92.6,341c-6.8,2.4-13.2,4.5-19.3,7c-8.9,3.6-15.1,9.7-18,19.2c-5.4,17.8-7.5,36-8.9,54.4 c-0.4,4.8-0.3,9.6-1,14.3c-0.8,5.6-0.1,10.3,5.4,13.2c60.1,0,120.3,0,180.4,0c5.2-1.9,6.2-5.9,5.7-10.9 C235.7,425.7,235.1,413.2,233.6,400.7z"/><path d="M100.4,288.2c2,0.5,2.6,1.5,3.3,3.2c4.1,9.5,9.1,18.5,16.9,25.6c14.6,13.4,31,10.9,43.6-2.6c6.3-6.8,10.9-14.8,14.3-23.5 c0.3-0.9,1.1-2.1,1.9-2.3c7.5-1.8,10-7.7,11.3-14.3c1-4.8-0.4-6.5-5-7.9c0.1-0.7,0.2-1.4,0.3-2.1c1.6-8.6,3.2-17.1,1.6-25.9 c-1.4-7.4-4.3-13.9-11.5-17.3c-2.9-1.4-4.8-3.2-6-6.3c-0.6-1.6-2.1-3-3.4-4.1c-6.4-5-14.1-6-21.7-5.9c-11.5,0.3-22.5,3-32.4,9.2 c-12.4,7.6-20.1,18.3-19.9,33.3c0.1,6.4,0.8,12.8,1.2,18.9c-1.3,1-3.6,1.7-4.1,3.1C88.8,275.7,93.2,286.3,100.4,288.2z"/></g><g id="warehouse-sterile-hospital"><polygon points="402.2,93.5 371.4,93.5 371.4,117.3 346.6,117.3 346.6,93.5 315.8,93.5 315.8,171.3 402.2,171.3 "/><polygon points="371.4,292.3 346.6,292.3 346.6,266.5 315.8,266.5 315.8,342.3 402.2,342.3 402.2,266.5 371.4,266.5 "/><path d="M428.1,124.8V198l-141.2,1v-74.2H256v324.3h30.9v-44.8h141.2v44.8H459V124.8H428.1z M286.9,367.8V236.5h141.2v131.3H286.9z "/><path d="M221.9,401.3c-1.1-8.8-2.8-17.6-4.8-26.3c-1.5-6.3-3.2-12.8-8.6-17.3c-7.3-6.1-16.3-8.6-25.2-11.3c0,3.7,0.2,7.1,0,10.4 c-0.2,3.4-1,6.7-1.2,10c-0.1,0.8,0.9,1.9,1.7,2.3c7.4,4.1,12,12,11,21.7c-0.6,5.4-0.7,11-1.4,16.4c-0.7,5.6-1.4,11.3-3,16.6 c-2.2,7.4-8,10.3-15,8.3c-2.1-0.6-3-1.9-2.8-3.9c0.3-2,1.5-3.5,3.8-3.5c5.7,0.1,7-0.5,7.8-6.2c1.3-9,2.1-18.1,3-27.2 c0.2-2.4,0.2-5-0.3-7.3c-1.4-5.7-6.8-9.8-12.7-10.1c-5.5-0.2-11.4,2.7-13.8,9.1c-3.3,8.6-6.5,17.2-9.4,25.9 c-2.1,6.3-1.2,7.6,4.4,11.5c1,0.7,1.9,2.8,1.7,4c-0.3,1.2-2.2,2.9-3.2,2.8c-5.5-0.5-10.8-3.9-11.1-10c-0.1-3.1,0.1-6.5,1-9.4 c2.6-8.3,5.5-16.5,8.6-24.7c1.3-3.3,3-6.5,5.1-9.3c4.2-5.4,10.3-7.1,16.9-7.5c2-6.7,2.1-13.4,1.2-20.1c-0.1-0.9-1-2.1-1.8-2.3 c-3.8-1.3-7.7-2.3-11.5-3.4c-4.3,13.8-10.2,26.6-18,39c-3.3-9.4-3.7-17.7-1.3-24.2c-2.6-2.1-5.1-4.3-7.7-6.5 c-2,1.7-3.8,3.6-5.9,5.1c-1.8,1.2-1.4,2.3-0.8,4c0.7,2.1,1,4.3,1,6.5c0,2-0.7,4.1-1.1,6.1c-0.6,2.9-1.1,5.7-1.9,9.2 c-8.3-12.6-13.8-25.6-18-39.4c-2.5,0.8-4.9,1.3-7.2,2.3c-1.2,0.5-2.6,1.7-2.9,2.8c-1.8,6.5-4.1,12.9-4.7,19.5 c-1.1,12.7-0.1,25.3,3.8,37.5c1,3.3,1.8,6,6.3,6.9c5.2,1,8,7.7,6.3,12.4c-2.1,5.6-7.5,8.5-12.8,6.7c-6.5-2.2-9-9.2-5.6-15.3 c0.5-1,0.7-2.5,0.4-3.5c-2.7-8-4.7-16.2-5.4-24.6c-0.9-10.3-1-20.5,1.2-30.6c0.7-2.9,1.3-5.8,2.1-9.3c-6.4,2.3-12.3,4.2-18.1,6.5 c-8.3,3.4-14.2,9.1-16.9,18c-5.1,16.6-7,33.7-8.3,51c-0.3,4.5-0.3,9-1,13.4c-0.8,5.3-0.1,9.6,5.1,12.3c56.3,0,112.6,0,168.9,0 c4.9-1.8,5.8-5.5,5.4-10.2C223.9,424.7,223.3,412.9,221.9,401.3z"/><path d="M96,190.8c25.5,0.1,51,0.1,76.5,0c7.1,0,13-6,13-13.1c0.1-25.4,0-50.8,0-76.2c0-4.2-1.7-7.8-5.2-10.3c-1.8-1.3-4-2.1-6-3.1 c-26.7,0-53.4,0-80.1,0c-0.4,0.2-0.8,0.5-1.2,0.6c-5.7,1.5-10,6.8-10,12.5c0,25.4-0.1,50.8,0,76.2C83.1,184.8,88.9,190.8,96,190.8z M92.9,102.5c0-3.2,1.1-4.3,4.3-4.3c24.8,0,49.6,0,74.4,0c3.1,0,4.2,1.1,4.2,4.1c0,12.4,0,24.9,0,37.3c0,12.4,0,24.9,0,37.3 c0,3-1.1,4.2-4.2,4.2c-24.9,0-49.7,0-74.6,0c-2.9,0-4.1-1.2-4.1-4C92.9,152.2,92.9,127.4,92.9,102.5z"/><path d="M88.3,278.2c-1.9,6,2.2,15.9,9,17.7c1.9,0.5,2.5,1.4,3.1,3c3.9,8.9,8.5,17.3,15.8,24c13.7,12.6,29,10.2,40.8-2.5 c5.9-6.4,10.2-13.9,13.4-22c0.3-0.8,1-1.9,1.8-2.1c7-1.7,9.4-7.2,10.6-13.4c0.9-4.5-0.4-6.1-4.7-7.4c0.1-0.6,0.2-1.3,0.3-2 c1.5-8,3-16,1.5-24.2c-1.3-6.9-4.1-13-10.8-16.2c-2.7-1.3-4.5-3-5.6-5.9c-0.5-1.5-1.9-2.8-3.2-3.8c-6-4.7-13.2-5.6-20.3-5.5 c-10.7,0.2-21.1,2.9-30.4,8.6c-11.6,7.1-18.8,17-18.6,31.1c0.1,6,0.8,12,1.1,17.7C90.9,276.2,88.7,276.9,88.3,278.2z"/><path d="M124.3,169.6c6.8,0,13.3,0,20,0c0-6.7,0-13.3,0-20.1c6.8,0,13.5,0,20.1,0c0-6.7,0-13.2,0-20c-6.8,0-13.4,0-20.2,0 c0-6.8,0-13.3,0-20c-6.7,0-13.2,0-20,0c0,6.7,0,13.4,0,20.2c-6.9,0-13.4,0-20,0c0,6.7,0,13.2,0,19.9c6.7,0,13.3,0,20.1,0 C124.3,156.4,124.3,163,124.3,169.6z"/></g><g id="document-transport-supplier"><path d="M422.7,145.3c-11.9,0-21.7-9.7-21.7-21.7V72.9h-94.1c-11.9,0-21.7,9.7-21.7,21.7v203.6c0,11.9,9.8,21.6,21.7,21.6h144.8 c11.9,0,21.7-9.7,21.7-21.7V145.3H422.7z M393.7,276h-57.9c-4,0-7.2-3.2-7.2-7.2c0-3.9,3.2-7.2,7.2-7.2h57.9c4,0,7.2,3.2,7.2,7.2 S397.8,276,393.7,276z M422.7,247h-86.9c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2h86.9c4,0,7.2,3.2,7.2,7.2S426.7,247,422.7,247z M422.7,218.1h-86.9c-4,0-7.2-3.2-7.2-7.2s3.2-7.2,7.2-7.2h86.9c4,0,7.2,3.2,7.2,7.2S426.7,218.1,422.7,218.1z M422.7,189.1h-86.9 c-4,0-7.2-3.2-7.2-7.2c0-3.9,3.2-7.2,7.2-7.2h86.9c4,0,7.2,3.2,7.2,7.2S426.7,189.1,422.7,189.1z"/><path d="M422,132.3h51.3l-59.2-59.3v51.3C414.1,128.6,417.6,132.3,422,132.3z"/><path d="M247.2,392.8c-1.3-10-3.2-20-5.5-29.9c-1.7-7.2-3.7-14.6-9.8-19.7c-8.3-6.9-18.5-9.7-28.7-12.8c0,0.1,0,0.1,0,0.2 l-15.3-4.4c-2.9-0.9-5.8-1.6-8.5-2.4c-4.9,15.7-11.6,30.2-20.5,44.4c-3.7-10.8-4.2-20.1-1.5-27.6c-2.9-2.4-5.9-4.9-8.8-7.3 c-2.2,1.9-4.3,4-6.7,5.8c-2,1.4-1.5,2.7-1,4.6c0.7,2.3,1.2,4.9,1.2,7.5c0,2.3-0.7,4.7-1.3,6.9c-0.6,3.2-1.3,6.5-2.1,10.5 c-9.5-14.4-15.8-29.2-20.6-44.7L97,329.3c-7.2,2.6-14.1,4.8-20.6,7.5c-9.5,3.8-16.1,10.3-19.2,20.5c-5.8,19-8,38.3-9.5,57.9 c-0.4,5.1-0.3,10.2-1.1,15.2c-0.9,6-0.1,11,5.8,14.1c64,0,128.1,0,192.2,0c5.5-2,6.6-6.3,6.1-11.6 C249.4,419.5,248.8,406.2,247.2,392.8z"/><path d="M105.3,273c2.1,0.5,2.8,1.6,3.5,3.4c4.4,10.1,9.7,19.7,18,27.3c15.6,14.3,33,11.6,46.4-2.8c6.7-7.2,11.6-15.8,15.2-25 c0.3-1,1.2-2.2,2-2.4c8-1.9,10.7-8.2,12-15.2c1.1-5.1-0.4-6.9-5.3-8.4c0.1-0.7,0.2-1.5,0.3-2.2c1.7-9.2,3.4-18.2,1.7-27.6 c-1.5-7.9-4.6-14.8-12.2-18.4c-3.1-1.5-5.1-3.4-6.4-6.7c-0.6-1.7-2.2-3.2-3.6-4.4c-6.8-5.3-15-6.4-23.1-6.3 c-12.2,0.3-24,3.2-34.5,9.8c-13.2,8.1-21.4,19.5-21.2,35.5c0.1,6.8,0.9,13.6,1.3,20.1c-1.4,1.1-3.8,1.8-4.4,3.3 C92.9,259.7,97.6,271,105.3,273z"/></g><g id="check-in-verification-and-check-material"><path d="M146.1,159.9c5-21.9,10.1-43.7,15-65.6c1.1-4.9,0.6-9.8-1.7-14.4c-1.6-3.2-4.1-5.4-7.3-7.2c-0.2,1-0.4,1.7-0.6,2.3 c-4.7,20.1-9.4,40.3-14.1,60.4c-0.4,1.6-1.1,2.4-2.5,3c-5.5,2.3-10.9,4.7-16.3,6.9c-1.7,0.7-2.6,1.7-3.1,3.4c-7,22-14.1,44-21.1,66 c-0.9,2.7-1.2,2.8-3.5,1.4c-4.8-3-10.1-4.2-15.7-3.3c-10.9,1.8-19.2,12-18.9,23.3c0.3,11.9,9,21.5,20.5,22.8 c11,1.2,21.4-6.5,24.1-17.6c0.9-3.8,2.2-7.5,3.2-11.4c0.3-1.3,1-1.6,2.1-1.6c2.7,0.1,5.4,0,8.1,0c2.4,0,3.7-1.1,3.6-2.9 c0-1.8-1.3-2.8-3.6-2.8c-2.5,0-5,0-7.7,0c0.2-0.7,0.2-1.1,0.3-1.5c5.6-16.7,11.1-33.4,16.7-50.1c0.3-0.9,1.3-1.9,2.2-2.3 c6-2.5,12.2-4.8,18.3-7.1C145.1,161.6,145.8,161.1,146.1,159.9z M78.8,249.9c-6.2,0-13.8-5.3-13.5-13.9c0.2-7.7,6.1-14,13.6-13.9 c7.9,0,13.4,6.2,13.5,13.9C92.3,243.6,86.2,249.9,78.8,249.9z M130.9,159.7c-3,0-5.5-2.6-5.6-5.7c-0.1-3.2,2.4-5.8,5.5-5.8 c3.1,0,5.6,2.5,5.6,5.7C136.5,157.1,134,159.7,130.9,159.7z"/><path d="M154.5,223c-2.7,0-5,0-7.3,0c-2.1,0-3.3,1-3.3,2.8c0,1.8,1.2,2.8,3.3,2.8c2.6,0,5.3-0.1,7.9,0.1c0.6,0,1.5,0.6,1.7,1.2 c1.2,3.6,2.4,7.2,3.2,10.9c2.8,12.8,15.2,20.9,27.6,17.7c11.9-3.1,19.7-15.4,16.3-28.7c-3.8-15.2-20.6-21.8-33.7-13.6 c-2.2,1.4-2.6,1.3-3.4-1.3c-5-15.5-9.9-31.1-14.9-46.6c-0.7-2.3-1.5-4.5-2.1-6.2c-2.4,1.1-4.5,2.2-6.8,3.2 c-1.4,0.6-2.9,1.2-4.4,1.7c-2.4,0.9-2.4,0.9-1.6,3.4c4.5,13.5,9,26.9,13.5,40.4C151.8,214.7,153.1,218.7,154.5,223z M182.3,222.1 c7.6,0.2,13.3,5.6,13.6,13.7c0.3,7.5-5.8,14.1-13.7,14.1c-7.4,0-13.4-6.2-13.4-13.8C168.7,228.3,174.8,222.1,182.3,222.1z"/><path d="M111.7,145.3c0.2,0.6,0.3,1.3,0.5,1.9c1.3-2.9,3.8-3.7,6.2-4.7c1.6-0.6,3.2-1.5,4.9-2.1c1.3-0.5,1.7-1.1,1.3-2.6 c-2.3-9.3-4.5-18.6-6.6-27.9c-1.7-7.3-3.5-14.7-5.2-22c-1.2-5-2.4-10-3.6-15.3c-3.8,2.1-6.4,4.8-7.9,8.6c-1.8,4.5-1.9,9.2-0.9,13.9 C104,112,107.8,128.7,111.7,145.3z"/><path d="M348.8,138.7c-22.8,0-41.3,18.5-41.3,41.3c0,22.8,18.5,41.3,41.3,41.3c22.8,0,41.3-18.5,41.3-41.3 C390.1,157.2,371.6,138.7,348.8,138.7z M365.5,186.2h-10.4v10.4c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3v-10.4h-10.4 c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h10.4v-10.4c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3v10.4h10.4 c3.5,0,6.3,2.8,6.3,6.3C371.8,183.4,368.9,186.2,365.5,186.2z"/><path d="M437.2,109h-46.7V93.6c0-9.4-7.6-17-17-17h-49.3c-9.4,0-17,7.6-17,17V109h-46.7c-10.4,0-18.8,8.5-18.8,18.8V231 c0,10.4,8.5,18.8,18.8,18.8h176.7c10.4,0,18.8-8.5,18.8-18.8V127.8C456,117.4,447.5,109,437.2,109z M319.7,93.6 c0-2.5,2-4.5,4.5-4.5h49.3c2.5,0,4.5,2,4.5,4.5V109h-58.2V93.6z M348.8,233.8c-29.7,0-53.8-24.1-53.8-53.8 c0-29.7,24.1-53.8,53.8-53.8c29.7,0,53.8,24.2,53.8,53.8S378.5,233.8,348.8,233.8z"/><path d="M388.4,370.5l-51.7-51.4c-3.9-3.9-10.1-3.8-14,0c-3.9,3.9-3.8,10.1,0,14l34.7,34.5H148.1c-5.5,0-9.9,4.4-9.9,9.9 c0,5.5,4.4,9.9,9.9,9.9h209.4L322.8,422c-3.9,3.9-3.9,10.1,0,14c3.9,3.9,10.1,3.9,14,0l51.7-51.4c0,0,0,0,0,0 C392.3,380.7,392.3,374.4,388.4,370.5C388.4,370.6,388.4,370.5,388.4,370.5z"/></g><g id="check-out-verification-and-check-material"><path d="M146.1,159.9c5-21.9,10.1-43.7,15-65.6c1.1-4.9,0.6-9.8-1.7-14.4c-1.6-3.2-4.1-5.4-7.3-7.2c-0.2,1-0.4,1.7-0.6,2.3 c-4.7,20.1-9.4,40.3-14.1,60.4c-0.4,1.6-1.1,2.4-2.5,3c-5.5,2.3-10.9,4.7-16.3,6.9c-1.7,0.7-2.6,1.7-3.1,3.4c-7,22-14.1,44-21.1,66 c-0.9,2.7-1.2,2.8-3.5,1.4c-4.8-3-10.1-4.2-15.7-3.3c-10.9,1.8-19.2,12-18.9,23.3c0.3,11.9,9,21.5,20.5,22.8 c11,1.2,21.4-6.5,24.1-17.6c0.9-3.8,2.2-7.5,3.2-11.4c0.3-1.3,1-1.6,2.1-1.6c2.7,0.1,5.4,0,8.1,0c2.4,0,3.7-1.1,3.6-2.9 c0-1.8-1.3-2.8-3.6-2.8c-2.5,0-5,0-7.7,0c0.2-0.7,0.2-1.1,0.3-1.5c5.6-16.7,11.1-33.4,16.7-50.1c0.3-0.9,1.3-1.9,2.2-2.3 c6-2.5,12.2-4.8,18.3-7.1C145.1,161.6,145.8,161.1,146.1,159.9z M78.8,249.9c-6.2,0-13.8-5.3-13.5-13.9c0.2-7.7,6.1-14,13.6-13.9 c7.9,0,13.4,6.2,13.5,13.9C92.3,243.6,86.2,249.9,78.8,249.9z M130.9,159.7c-3,0-5.5-2.6-5.6-5.7c-0.1-3.2,2.4-5.8,5.5-5.8 c3.1,0,5.6,2.5,5.6,5.7C136.5,157.1,134,159.7,130.9,159.7z"/><path d="M154.5,223c-2.7,0-5,0-7.3,0c-2.1,0-3.3,1-3.3,2.8c0,1.8,1.2,2.8,3.3,2.8c2.6,0,5.3-0.1,7.9,0.1c0.6,0,1.5,0.6,1.7,1.2 c1.2,3.6,2.4,7.2,3.2,10.9c2.8,12.8,15.2,20.9,27.6,17.7c11.9-3.1,19.7-15.4,16.3-28.7c-3.8-15.2-20.6-21.8-33.7-13.6 c-2.2,1.4-2.6,1.3-3.4-1.3c-5-15.5-9.9-31.1-14.9-46.6c-0.7-2.3-1.5-4.5-2.1-6.2c-2.4,1.1-4.5,2.2-6.8,3.2 c-1.4,0.6-2.9,1.2-4.4,1.7c-2.4,0.9-2.4,0.9-1.6,3.4c4.5,13.5,9,26.9,13.5,40.4C151.8,214.7,153.1,218.7,154.5,223z M182.3,222.1 c7.6,0.2,13.3,5.6,13.6,13.7c0.3,7.5-5.8,14.1-13.7,14.1c-7.4,0-13.4-6.2-13.4-13.8C168.7,228.3,174.8,222.1,182.3,222.1z"/><path d="M111.7,145.3c0.2,0.6,0.3,1.3,0.5,1.9c1.3-2.9,3.8-3.7,6.2-4.7c1.6-0.6,3.2-1.5,4.9-2.1c1.3-0.5,1.7-1.1,1.3-2.6 c-2.3-9.3-4.5-18.6-6.6-27.9c-1.7-7.3-3.5-14.7-5.2-22c-1.2-5-2.4-10-3.6-15.3c-3.8,2.1-6.4,4.8-7.9,8.6c-1.8,4.5-1.9,9.2-0.9,13.9 C104,112,107.8,128.7,111.7,145.3z"/><path d="M348.8,138.7c-22.8,0-41.3,18.5-41.3,41.3c0,22.8,18.5,41.3,41.3,41.3c22.8,0,41.3-18.5,41.3-41.3 C390.1,157.2,371.6,138.7,348.8,138.7z M365.5,186.2h-10.4v10.4c0,3.5-2.8,6.3-6.3,6.3c-3.5,0-6.3-2.8-6.3-6.3v-10.4h-10.4 c-3.5,0-6.3-2.8-6.3-6.3c0-3.5,2.8-6.3,6.3-6.3h10.4v-10.4c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3v10.4h10.4 c3.5,0,6.3,2.8,6.3,6.3C371.8,183.4,368.9,186.2,365.5,186.2z"/><path d="M437.2,109h-46.7V93.6c0-9.4-7.6-17-17-17h-49.3c-9.4,0-17,7.6-17,17V109h-46.7c-10.4,0-18.8,8.5-18.8,18.8V231 c0,10.4,8.5,18.8,18.8,18.8h176.7c10.4,0,18.8-8.5,18.8-18.8V127.8C456,117.4,447.5,109,437.2,109z M319.7,93.6 c0-2.5,2-4.5,4.5-4.5h49.3c2.5,0,4.5,2,4.5,4.5V109h-58.2V93.6z M348.8,233.8c-29.7,0-53.8-24.1-53.8-53.8 c0-29.7,24.1-53.8,53.8-53.8c29.7,0,53.8,24.2,53.8,53.8S378.5,233.8,348.8,233.8z"/><path d="M141.1,370.5l51.7-51.4c3.9-3.9,10.1-3.8,14,0c3.9,3.9,3.8,10.1,0,14l-34.7,34.5h209.4c5.5,0,9.9,4.4,9.9,9.9 c0,5.5-4.4,9.9-9.9,9.9H172.1l34.7,34.5c3.9,3.9,3.9,10.1,0,14c-3.9,3.9-10.1,3.9-14,0l-51.7-51.4c0,0,0,0,0,0 C137.3,380.7,137.3,374.4,141.1,370.5C141.1,370.6,141.1,370.5,141.1,370.5z"/></g><g id="warehouse"><path d="m283 139l49 0 0 15-49 0z m59 0l29 0 0 15-29 0z m-185 192l49 0 0 14-49 0z m59 0l29 0 0 14-29 0z m274-317l-45 0c-2 0-4 2-4 5l0 15 0 0 0 144-39 0 0-77-145 0 0-38-151 0 0 115-31 0 0-159c0-3-2-5-5-5l-48 0c-2 0-4 2-4 5l0 480 57 0 0-86 366 0 0 86 53 0 0-480c0-3-2-5-4-5z m-233 102l131 0 0 62-131 0c0 0 0-62 0-62z m-88-39l25 0 0 43-25 0z m-48 0l34 0 0 58 53 0 0-58 34 0 0 101-121 0z m141 292l-131 0 0-62 131 0z m135 0l-121 0 0-100 34 0 0 57 53 0 0-57 34 0 0 100z m-72-57l0-43 24 0 0 43z m116 57l-29 0 0-115-150 0 0 39-146 0 0 76-41 0 0-148 366 0z"/></g><g id="washing"><path class="st0" d="M310,161.3v13.5c0,1.8,1.4,3.2,3.2,3.2h25c1.8,0,3.2-1.4,3.2-3.2v-13.5c0-1.8-1.4-3.2-3.2-3.2h-25 C311.4,158.2,310,159.6,310,161.3 M179.8,263.5c0,1.8,1.6,3.3,3.5,3.3h105.8c1.9,0,3.5-1.5,3.5-3.3c0-1.8-1.6-3.3-3.5-3.3H183.3 C181.4,260.2,179.8,261.7,179.8,263.5 M179.8,239.5c0,1.8,1.6,3.3,3.5,3.3h105.8c1.9,0,3.5-1.5,3.5-3.3c0-1.8-1.6-3.3-3.5-3.3 H183.3C181.4,236.2,179.8,237.7,179.8,239.5 M179.8,216.1c0,1.8,1.6,3.3,3.5,3.3h105.8c1.9,0,3.5-1.5,3.5-3.3 c0-1.8-1.6-3.3-3.5-3.3H183.3C181.4,212.8,179.8,214.3,179.8,216.1 M179.8,191.8c0,1.8,1.6,3.3,3.5,3.3h105.8 c1.9,0,3.5-1.5,3.5-3.3s-1.6-3.3-3.5-3.3H183.3C181.4,188.5,179.8,190,179.8,191.8 M179.8,168.1c0,1.8,1.6,3.3,3.5,3.3h105.8 c1.9,0,3.5-1.5,3.5-3.3c0-1.8-1.6-3.3-3.5-3.3H183.3C181.4,164.8,179.8,166.3,179.8,168.1 M176.5,140.9c0-1.8,1.4-3.2,3.2-3.2 h113.2c1.8,0,3.2,1.4,3.2,3.2v147.3c0,1.7-1.4,3.2-3.2,3.2H179.7c-1.8,0-3.2-1.4-3.2-3.2V140.9z M344.7,288.1 c0,1.7-1.4,3.2-3.2,3.2h-31c-1.8,0-3.2-1.4-3.2-3.2V140.9c0-1.8,1.4-3.2,3.2-3.2h31c1.8,0,3.2,1.4,3.2,3.2 M163.8,124.9v343 c0,1.8,1.4,3.2,3.2,3.2h187.5c1.8,0,3.2-1.4,3.2-3.2v-343c0-1.8-1.4-3.2-3.2-3.2H166.9C165.2,121.7,163.8,123.1,163.8,124.9 M357.7,114.6V38.4c0-1.8-1.4-3.2-3.2-3.2H166.9c-1.7,0-3.2,1.4-3.2,3.2v76.3c0,1.8,1.4,3.2,3.2,3.2h187.5 C356.2,117.8,357.7,116.4,357.7,114.6"/></g><g id="kit-griglie"></g><g id="first-aid-kit"><path d="m346 241c0 0 0 0 0 0l-43 0 0-43c0-9-7-16-16-16 0 0 0 0 0 0l-62 0c-9 0-16 7-16 16l0 43-43 0c-8 0-15 7-15 15 0 0 0 0 0 0l0 62c0 9 7 16 15 16l43 0 0 43c0 9 7 16 16 16 0 0 0 0 0 0l62 0c9 0 16-7 16-16l0-43 43 0c8 0 15-7 15-16 0 0 0 0 0 0l0-62c0-8-7-15-15-15z m-6 72l-48 0c-6 0-10 5-10 10l0 49-52 0 0-49c0-5-4-10-10-10l-48 0 0-51 48 0c6 0 10-5 10-11l0-48 51 0 0 48c0 6 5 11 11 11l48 0z m99-210l-86 0 0-37c0-17-13-31-30-31-1-1-2-1-3 0l-128 0c-17-1-32 12-32 29-1 0-1 1 0 2l0 37-87 0c-34 0-73 19-73 73l0 229c0 53 39 73 73 73l366 0c34 0 73-20 73-73l0-229c0-54-39-73-73-73z m-258-37c0-3 0-11 11-11l128 0c12 0 12 8 12 11l0 37-151 0z m310 339c0 46-36 51-52 51l-366 0c-16 0-52-5-52-51l0-229c0-47 36-52 52-52l366 0c16 0 52 5 52 52z"/></g><g id="garments"><path d="m458 102c0-26-18-53-52-53-1 7-2 14-4 21-8 31-18 62-31 91-5 11-10 22-17 32-10 16-21 20-38 12-13-5-25-13-37-21-10-7-10-7-20 0-12 9-26 18-41 23-13 4-23 1-31-11-4-5-7-10-10-15-13-26-23-54-32-82-5-16-12-32-11-51-4 1-8 1-11 2-25 4-42 25-42 51 0 49 0 97 0 146 0 3 0 5 1 7 7 18 17 33 36 39 35 12 71 24 107 36 11 3 16 10 14 22-5 27-10 54-15 81-1 9-8 14-17 15-31 0-62-3-93-8-11-1-22-4-33-6 0 7 0 14 0 21 0 27 17 44 43 44 97 0 193 0 290 0 24 1 44-18 44-45-1-117-1-234 0-351z m-189 360c-7 0-13-7-13-15 0-7 6-13 13-13 8 0 14 6 14 14 0 7-6 14-14 14z m-13-123c0-7 6-13 14-13 7 1 13 7 13 14 0 8-7 14-14 14-8-1-13-7-13-15z m13-93c-8-1-13-7-13-14 0-8 6-14 14-14 7 1 13 7 13 14 0 8-6 14-14 14z m-91-105c6 14 13 28 20 41 6 10 10 11 20 7 19-8 35-21 50-34-27-28-52-58-75-90-3-5-6-10-10-15-2-4-1-6 3-8 4-2 7-4 12-4 19-3 38-5 57-6 26-1 51-1 76 4 8 1 15 4 22 6 4 1 5 4 2 8-2 4-5 9-8 13-23 33-49 63-78 93 15 10 30 20 44 29 4 3 8 4 12 5 5 2 10 1 13-4 4-6 8-12 11-18 16-34 28-69 38-105 2-10 0-19-8-24-8-5-16-10-25-13-52-16-105-16-158-4-13 3-25 8-36 17-8 6-11 14-8 24 9 26 17 52 26 78z m6 288c8 0 16 0 23 0 6-28 10-55 15-83-1 0-3-1-4-1-35-12-71-24-106-36-26-9-40-30-49-57 0-3-1-6-2-9 0 0-1 0-1 0-1 7-2 14-3 21-4 39-4 78 2 117 5 32 6 29 27 35 32 8 65 12 98 13z m-1-34c6 0 10 4 10 10 0 6-4 10-10 10-6 0-10-4-10-10 0-6 5-11 10-10z"/></g><g id="medical-history"><path d="m96 363l43 0 0 21-43 0z m0 42l64 0 0 22-64 0z m406 51l-118-118 0-263c0-18-14-32-32-32l-214 0c-5-25-27-43-53-43-25 0-47 18-52 43l-1 0c-18 0-32 14-32 32l0 405c0 18 14 32 32 32l320 0c18 0 32-14 32-32l0-50 72 72c6 7 15 10 23 10 9 0 17-3 23-10 13-12 13-33 0-46z m-417-435c14 0 26 9 31 22l-61 0c5-13 16-22 30-22z m278 459c0 6-5 11-11 11l-320 0c-6 0-11-5-11-11l0-405c0-6 5-11 11-11l85 0 0 117c0 6-4 11-10 11-6 0-11-5-11-11l0-96-21 0 0 96c0 18 14 32 32 32 17 0 32-14 32-32l0-117 213 0c6 0 11 5 11 11l0 241-32-32 0-188c0-6-5-11-11-11l-160 0 0 22 149 0 0 158-59-29c-3-2-6-2-9 0-1 0-2 0-2 1l0 0-30 22-17-59c-1-2-2-4-3-5-4-4-11-4-15 0l-29 29-81 0c-6 0-11 5-11 11l0 224c0 6 5 10 11 10l256 0c6 0 11-4 11-10l0-82 32 32z m-84-190l-10-21 21 10z m30 66l0 92-234 0 0-203 74 0c3 0 6-1 8-3l19-19 16 57c1 2 1 3 2 4 4 4 10 5 15 2l32-24 26 51 0 0c1 1 1 1 2 2z m-17-48l16-16 141 141-16 16z m195 179c-4 5-11 5-16 0l-23-23 16-16 23 23c5 5 5 12 0 16z"/></g><g id="pieghatura"><path d="m71 243c51 0 103 0 154 0 26 0 53 0 79 0 15-1 23-12 20-24-3-9-10-13-21-13-74 0-148 0-221 0-5 0-10 0-15 0-6-1-11-5-11-11-1-7 3-12 10-13 2-1 4-1 6-1 77 0 154 0 230 0 6 0 11 1 16 2 21 6 34 26 31 46-3 22-20 37-42 37-42 1-83 0-125 0-12 0-25 0-38 0-29 0-59 0-88 0-9 0-15 4-19 12-3 7-1 13 3 19 5 5 11 6 18 6 82 0 164 0 247 0 23 0 44-8 60-25 38-42 75-84 113-126 4-5 8-11 11-18 21-52-17-109-74-109-68-1-136-1-204 0-16 0-31 5-44 15-43 38-86 76-129 114-23 21-25 49-8 71 11 12 25 18 41 18z m382-24c-2 2-4 4-6 7-19 21-38 42-57 63-24 27-53 41-90 40-77 0-153 0-230 0-5 0-11 1-16 2-23 7-38 29-34 54 3 24 23 42 48 42 58 0 117 0 175 0 21 0 42 0 63 0 11 0 18-8 18-18 1-10-7-18-17-19-2 0-4 0-6 0-76 0-152 0-228 0-12 0-17-4-17-12 0-8 5-12 17-12 19 0 39 0 58 0 59 0 117 0 176 0 26 0 46 23 42 49-3 21-21 36-44 36-67 0-134 0-201 0-17 0-34 0-51 0-10 1-17 9-17 19 0 10 7 17 18 18 2 0 5 0 7 0 81 0 163 0 244 0 24 0 44-8 60-25 36-40 72-81 108-121 12-13 19-27 21-44 4-31-14-66-41-79z"/></g><g id="qualita"><path d="m359 374c-11 6-16 8-24 8-5 0-13-2-26-6-3-1-5-1-7 0-9 1-12 10-18 14-2 3-2 10-1 14 9 27 19 54 29 81 1 3 3 7 7 14 1-2 2-3 3-4 7-10 13-18 18-26 3-5 7-7 12-7 1 0 3 1 5 1 11 4 22 6 37 9-13-35-24-66-35-98z m-124 17c-6-5-12-12-20-13-1 0-1 0-1 0-1 0-1 0-1 0-3 0-7 2-11 4-6 4-13 6-20 5-6 0-11-1-16-4-2-1-4-3-5-4-9 31-18 62-27 92-1 5 0 8 4 8 1 0 2 0 4-1 3-1 6-2 8-3 3 0 5-1 7-2 4-1 7-2 10-3 3-1 6-2 8-2 4 0 8 3 11 7 7 9 14 17 23 27 3-8 5-12 6-16 7-24 14-48 20-73 2-7 10-14 0-22z m198-174c-21-34-20-21-2-56 0 0 0-1 0-1 6-9 5-17-5-22-22-10-36-24-27-46 5-16-1-21-14-21-26 1-41-11-47-36-3-9-10-13-19-8-23 13-43 10-59-11-7-8-15-7-20 1-15 22-34 26-58 15-10-4-17-1-19 10-4 25-19 38-45 38-9 0-15 6-12 16 7 24 2 43-22 54-11 5-11 13-5 23 21 34 21 21 1 56-5 11-5 19 7 23 23 10 31 26 26 50-3 11 2 17 14 17 25-2 41 10 47 35 2 10 10 14 19 9 23-14 42-9 59 11 6 7 14 7 19-1 16-21 34-27 59-15 9 4 17 0 18-10 4-25 19-38 45-38 11-1 16-8 13-18-8-24 1-41 23-53 10-5 10-13 4-22z m-173 98c-67 2-122-50-124-116-3-66 49-121 115-124 67-2 123 50 125 117 2 65-50 121-116 123z m-7-218c-55 2-97 47-95 101 1 54 47 96 101 95 54-2 97-47 95-101-2-55-47-97-101-95z m61 86l-25 27 7 36c0 0 0 1 0 1 0 1 0 2 0 3-1 1-2 1-3 1-1 0-2 0-3-1l-33-16-32 19c-1 0-2 0-3 1-1 0-2-1-2-1-1-1-1-2-1-3 0 0 0-1 0-1l5-37-27-25c-1-1-2-2-2-3 0-2 1-3 4-4l36-6 15-34c1-2 2-3 4-3 1 0 2 1 3 3l18 33 37 4c2 0 4 1 4 3 0 1-1 2-2 3z"/></g><g id="quality"><path class="st0" d="M467.1,110.7c-9.3-15.9-21.9-28.5-37.8-37.8C413.4,63.6,396.1,59,377.2,59c-18.8,0-36.2,4.6-52.1,13.9 c-15.9,9.3-28.5,21.9-37.8,37.8c-9.3,15.9-13.9,33.3-13.9,52.1c0,18.8,4.6,36.2,13.9,52.1c9.3,15.9,21.9,28.5,37.8,37.8 c15.9,9.3,33.3,13.9,52.1,13.9c18.8,0,36.2-4.6,52.1-13.9c15.9-9.3,28.5-21.9,37.8-37.8c9.3-15.9,13.9-33.3,13.9-52.1 C481,143.9,476.4,126.6,467.1,110.7z M440.9,199.7c-6.6,11.3-15.5,20.2-26.8,26.8c-11.3,6.6-23.6,9.9-36.9,9.9 c-13.3,0-25.6-3.3-36.9-9.9c-11.3-6.6-20.2-15.5-26.8-26.8c-6.6-11.3-9.9-23.6-9.9-36.9c0-13.3,3.3-25.6,9.9-36.9 c6.6-11.3,15.5-20.2,26.8-26.8c11.3-6.6,23.6-9.9,36.9-9.9c13.3,0,25.6,3.3,36.9,9.9c11.3,6.6,20.2,15.5,26.8,26.8 c6.6,11.3,9.9,23.6,9.9,36.9C450.7,176.1,447.4,188.4,440.9,199.7z"/><path class="st0" d="M417.9,125.6c-1.7-1.7-3.7-2.6-6.1-2.6c-2.3,0-4.4,0.9-6.1,2.6l-37.2,37.2l-19.9-19.9 c-1.7-1.7-3.7-2.6-6.1-2.6c-2.3,0-4.4,0.9-6.1,2.6l-13.8,13.8c-1.7,1.7-2.6,3.7-2.6,6.1c0,2.3,0.9,4.4,2.6,6.1l39.7,39.7 c1.7,1.7,3.7,2.6,6.1,2.6c2.3,0,4.4-0.9,6.1-2.6l57-57c1.7-1.7,2.6-3.7,2.6-6.1c0-2.3-0.9-4.4-2.6-6.1L417.9,125.6z"/><path class="st0" d="M60.8,386.6H41.2c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C65.7,387.6,63.4,386.6,60.8,386.6z"/><path class="st0" d="M60.8,308.5H41.2c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C65.7,309.4,63.4,308.5,60.8,308.5z"/><path class="st0" d="M138.9,308.5h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C143.8,309.4,141.6,308.5,138.9,308.5z"/><path class="st0" d="M60.8,230.3H41.2c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C65.7,231.3,63.4,230.3,60.8,230.3z"/><path class="st0" d="M217.1,308.5h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C222,309.4,219.7,308.5,217.1,308.5z"/><path class="st0" d="M138.9,230.3h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C143.8,231.3,141.6,230.3,138.9,230.3z"/><path class="st0" d="M60.8,152.2H41.2c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C65.7,153.1,63.4,152.2,60.8,152.2z"/><path class="st0" d="M217.1,230.3h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C222,231.3,219.7,230.3,217.1,230.3z"/><path class="st0" d="M138.9,152.2h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C143.8,153.1,141.6,152.2,138.9,152.2z"/><path class="st0" d="M60.8,74H41.2c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9V83.8c0-2.6-1-4.9-2.9-6.9C65.7,75,63.4,74,60.8,74z"/><path class="st0" d="M217.1,152.2h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9v-19.5c0-2.6-1-4.9-2.9-6.9 C222,153.1,219.7,152.2,217.1,152.2z"/><path class="st0" d="M138.9,74h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9V83.8c0-2.6-1-4.9-2.9-6.9C143.8,75,141.6,74,138.9,74z "/><path class="st0" d="M217.1,74h-19.5c-2.7,0-4.9,1-6.9,2.9c-1.9,1.9-2.9,4.2-2.9,6.9v19.5c0,2.7,1,4.9,2.9,6.9 c1.9,1.9,4.2,2.9,6.9,2.9h19.5c2.6,0,4.9-1,6.9-2.9c1.9-1.9,2.9-4.2,2.9-6.9V83.8c0-2.6-1-4.9-2.9-6.9C222,75,219.7,74,217.1,74z" /></g><g id="packaging-box"><polygon points="282.8,247.8 261.2,260.3 261.2,485 455.7,372.7 455.7,148 "/><polygon points="318,46.3 243.2,3 43.3,118.4 118.2,161.7 "/><polygon points="443,118.4 356.8,69.3 157,184.7 168.4,190.6 243.2,233.8 317.6,190.9 "/><polygon points="141.9,267.3 106.1,248.9 106.1,191.7 32.3,149.2 32.3,372.3 225.4,483.8 225.4,260.7 141.9,212.6 "/></g><g id="home"><path d="M466,218.5l-69.2-69.2v-80c0-14.5-11.7-26.2-26.2-26.2c-14.4,0-26.2,11.7-26.2,26.2v27.6l-51.5-51.5 c-25.5-25.5-69.8-25.4-95.2,0L24.7,218.5c-10.2,10.2-10.2,26.8,0,37c10.2,10.2,26.8,10.2,37,0l173-173.1c5.6-5.6,15.6-5.6,21.2,0 L429,255.5c5.1,5.1,11.8,7.7,18.5,7.7c6.7,0,13.4-2.5,18.5-7.7C476.3,245.3,476.3,228.7,466,218.5z"/><path d="M254.4,132.1c-5-5-13.2-5-18.2,0L84,284.3c-2.4,2.4-3.8,5.7-3.8,9.1v111c0,26,21.1,47.2,47.2,47.2h75.4V334.9h85.1v116.7 h75.4c26,0,47.2-21.1,47.2-47.2v-111c0-3.4-1.4-6.7-3.8-9.1L254.4,132.1z"/></g><g id="cart"><path class="st0" d="M52.7,215.8c9.9,1.1,19.3-5.7,21.7-15.4c0.8-3.3,2-6.6,2.9-9.9c0.3-1.1,0.9-1.4,1.9-1.4c2.4,0.1,4.9,0,7.3,0 c2.1,0,3.3-0.9,3.3-2.6c0-1.5-1.2-2.4-3.2-2.4h-5.9c-0.6,0-1-0.4-0.9-1l0.1-0.3c5-14.6,10-29.2,15.1-43.7c0.3-0.8,1.2-1.6,2-2 c5.4-2.2,15.5-5.8,15.5-5.8c0.5-0.2,1.4-0.6,2-0.8c0,0,0.6-0.3,0.8-1.3c4.5-19.1,9.1-38.1,13.5-57.2c1-4.2,0.6-8.5-1.5-12.5 c-1.5-2.8-5.7-5.7-5.7-5.7c-0.5-0.3-1-0.1-1.2,0.4c0,0-0.1,0.4-0.3,1c-4.2,17.5-8.5,35.1-12.7,52.7c-0.3,1.4-1,2.1-2.3,2.6 c-4.9,2-9.8,4.1-14.7,6c-1.5,0.6-2.3,1.5-2.8,3c-6.3,19.2-12.7,38.4-19,57.5c-0.8,2.3-1.1,2.4-3.2,1.2c-4.3-2.6-9.1-3.7-14.1-2.9 c-9.9,1.6-17.3,10.4-17.1,20.4C34.6,206.3,42.4,214.7,52.7,215.8z M101.7,119c2.8,0,5.1,2.2,5.1,5c0,2.8-2.3,5-5,5 c-2.7,0-4.9-2.2-5-4.9C96.6,121.3,98.9,119,101.7,119z M54.8,183.5c7.1,0,12.1,5.4,12.1,12.1c0,6.6-5.5,12.1-12.2,12.2 c-5.6,0-12.4-4.6-12.2-12.1C42.7,188.9,48,183.5,54.8,183.5z"/><path class="st0" d="M179.1,181.8c0,0,4.2-3.5,6.7-5.5c2.5-2,5-3.8,7.5-5.6c1-0.7,1.3-1.4,1.3-2.6c0-18.6,0-37.1,0-55.7 c0-0.6,0-0.7,0-0.7c-0.1-0.6-0.6-1.1-1.2-1.1h-14c-0.6,0-1.1,0.5-1.1,1.1v69.6C178.3,182,178.7,182.2,179.1,181.8z"/><path class="st0" d="M85.2,270.7c-1.1-4.4-3-12.3-3-12.3c-0.1-0.6-0.6-0.7-1.1-0.4c0,0-4.9,3.6-6.3,6.9c-1.6,3.9-1.7,8-0.8,12.1 c3.4,14.6,6.9,29.1,10.3,43.7c0.1,0.5,0.2,0.6,0.2,0.6c0.1,0.6,0.6,0.7,1,0.3c0,0,2.6-2.5,4.8-3.4c1.5-0.5,2.9-1.3,4.4-1.8 c1.2-0.4,1.5-1,1.2-2.2c-2-8.1-4-16.2-6-24.3C88.4,283.5,86.8,277.1,85.2,270.7z"/><path class="st0" d="M156,115.4c19.6-19.5,45.7-29.9,74-29.2c26.5,0.7,51.6,11,69,28.4c6.9,6.9,16.7,21.7,16.7,21.7 c0.3,0.5,0.1,1-0.4,1.1l-18.7,4c-0.6,0.1-0.7,0.6-0.3,1l43.6,48.3c0.4,0.4,0.9,0.3,1-0.2l20-61.9c0.2-0.6-0.1-0.9-0.7-0.8l-20,4.3 c-0.6,0.1-1.3-0.2-1.6-0.7c0,0-13.7-22.6-23.7-32.6c-21.4-21.4-52.2-34.2-84.3-35C196.2,63,164,75.6,140.1,99.5 c-4.4,4.4-4.4,11.5,0,15.9C144.5,119.8,151.6,119.8,156,115.4z"/><path class="st0" d="M234.9,151.7c-0.6,0-1.1,0.5-1.1,1.1v12.1c0,0.6,0.5,1.1,1.1,1.1h61.9c0.6,0,1.1-0.5,1.1-1.1v-12.1 c0-0.6-0.5-1.1-1.1-1.1H234.9z"/><path class="st0" d="M119,132.2c-0.2-0.5-0.8-0.8-1.3-0.5c0,0-3.1,1.5-5.1,2.4c-1.3,0.5-2.6,1-3.9,1.5c-2.2,0.8-2.2,0.8-1.4,2.9 c4.1,11.7,8.1,23.5,12.2,35.2c1.2,3.4,3.2,9.6,3.2,9.6c0.2,0.6-0.1,1-0.7,1c0,0-3.5,0-5.6,0c-1.9,0-3,0.9-3,2.5 c0,1.6,1.1,2.5,3,2.5c2.4,0,4.7-0.1,7.1,0.1c0.5,0,0.8,0.3,0.8,0.3c0.4,0.4,0.9,1.2,1.1,1.8c0,0,1.8,5.3,2.6,8.5 c2.5,11.2,13.7,18.2,24.9,15.4c10.7-2.7,17.8-13.4,14.7-25c-3.4-13.3-18.6-19-30.4-11.9c-2,1.2-2.4,1.1-3.1-1.1 c-4.5-13.6-9-27.1-13.4-40.7C119.9,134.7,119,132.2,119,132.2z M147,183.9c0.5-0.2,1.4-0.3,1.9,0c0,0,11,4.5,11.3,11.5 c0.3,6.6-5.3,12.3-12.3,12.3c-6.6,0-12.1-5.4-12.1-12.1C135.8,188.9,147,183.9,147,183.9z"/><path class="st0" d="M84.4,116.6c0.1,0.5,0.2,0.6,0.2,0.6c0.1,0.6,0.6,0.7,1,0.3c0,0,2.6-2.5,4.8-3.4c1.5-0.5,2.9-1.3,4.4-1.8 c1.2-0.4,1.5-1,1.2-2.2c-2-8.1-4-16.2-6-24.3c-1.6-6.4-3.1-12.8-4.7-19.2c-1.1-4.4-3-12.3-3-12.3c-0.1-0.6-0.6-0.7-1.1-0.4 c0,0-4.9,3.6-6.3,6.9c-1.6,3.9-1.7,8-0.8,12.1C77.4,87.5,80.9,102,84.4,116.6z"/><path class="st0" d="M194.3,190.1c-0.1,0.1-0.7,0.5-1.2,0.8c0,0-9.1,7.2-14.1,11.1c-0.4,0.3-0.5,0.5-0.5,0.5 c-0.2,0.6-0.3,1.5-0.3,2.1c0,0-0.1,3.5,0,5.7c0.1,3.3,2.6,5.6,6,5.7c1.6,0,3.1,0,4.7,0c2.9-0.1,5.5-2.3,5.6-5.2 c0.1-6.9,0-19.8,0-19.8C194.5,190.4,194.4,190,194.3,190.1z"/><path class="st0" d="M194.6,173.9c0-0.6-0.4-0.8-0.8-0.4c0,0-7.4,6.1-11.6,8.9c-3.2,2.1-4.5,4.6-4.1,8.3c0.3,2.7,0.1,7.4,0.1,7.4 c0,0.6,0.1,1,0.2,1c0.2,0,0.8-0.5,1.2-0.8l13.4-10.6c0.5-0.4,1-0.8,1.1-1c0.2-0.2,0.3-1.2,0.3-1.8L194.6,173.9z"/><path class="st0" d="M114.5,334.7c0,0,0.6-0.3,0.8-1.3c4.5-19.1,9.1-38.1,13.5-57.2c1-4.2,0.6-8.5-1.5-12.5 c-1.5-2.8-5.7-5.6-5.7-5.6c-0.5-0.3-1-0.1-1.2,0.4c0,0-0.1,0.4-0.3,1c-4.2,17.5-8.5,35.1-12.7,52.7c-0.3,1.4-1,2.1-2.3,2.6 c-4.9,2-9.8,4.1-14.7,6c-1.5,0.6-2.3,1.5-2.8,3c-6.3,19.2-12.7,38.4-19,57.5c-0.8,2.3-1.1,2.4-3.2,1.2c-4.3-2.6-9.1-3.7-14.1-2.9 c-9.9,1.6-17.3,10.4-17.1,20.4c0.3,10.4,8.1,18.7,18.5,19.8c9.9,1.1,19.3-5.7,21.7-15.4c0.8-3.3,2-6.6,2.9-9.9 c0.3-1.1,0.9-1.4,1.9-1.4c2.4,0.1,4.9,0,7.3,0c2.1,0,3.3-1,3.3-2.6c0-1.5-1.2-2.4-3.2-2.4h-5.9c-0.6,0-1-0.4-0.9-1L80,387 c5-14.6,10-29.2,15.1-43.7c0.3-0.8,1.2-1.6,2-2c5.4-2.2,15.5-5.8,15.5-5.8C113.1,335.3,114,335,114.5,334.7z M54.7,411.9 c-5.6,0-12.4-4.6-12.2-12.1c0.2-6.7,5.5-12.2,12.2-12.1c7.1,0,12.1,5.4,12.1,12.1C66.9,406.4,61.4,411.8,54.7,411.9z M101.7,333.2 c-2.7,0-4.9-2.2-5-4.9c-0.1-2.8,2.2-5.1,5-5.1c2.8,0,5.1,2.2,5.1,5C106.7,330.9,104.5,333.2,101.7,333.2z"/><path class="st0" d="M474.9,305H333.4c-0.6,0-1.1,0.5-1.1,1.1v12.1c0,0.6,0.5,1.1,1.1,1.1h141.5c0.6,0,1.1-0.5,1.1-1.1v-12.1 C476,305.5,475.5,305,474.9,305z"/><path class="st0" d="M474.9,356.5h-110c-0.6,0-1.1,0.5-1.1,1.1v12.1c0,0.6,0.5,1.1,1.1,1.1h110c0.6,0,1.1-0.5,1.1-1.1v-12.1 C476,357,475.5,356.5,474.9,356.5z"/><path class="st0" d="M474.9,408.1h-240c-0.6,0-1.1,0.5-1.1,1.1v12.1c0,0.6,0.5,1.1,1.1,1.1h240c0.6,0,1.1-0.5,1.1-1.1v-12.1 C476,408.6,475.5,408.1,474.9,408.1z"/><path class="st0" d="M137.1,382.6c-2,1.2-2.4,1.1-3.1-1.1c-4.5-13.6-9-27.1-13.4-40.7c-0.7-2-1.5-4.4-1.5-4.4 c-0.2-0.5-0.8-0.8-1.3-0.5c0,0-3.1,1.5-5.1,2.4c-1.3,0.5-2.6,1-3.9,1.5c-2.2,0.8-2.2,0.8-1.4,2.9c4.1,11.7,8.1,23.5,12.2,35.2 c1.2,3.4,3.2,9.6,3.2,9.6c0.2,0.6-0.1,1-0.7,1c0,0-3.5,0-5.6,0c-1.9,0-3,0.9-3,2.5c0,1.6,1.1,2.5,3,2.5c2.4,0,4.7-0.1,7.1,0.1 c0.5,0,0.8,0.3,0.8,0.3c0.4,0.4,0.9,1.2,1.1,1.8c0,0,1.8,5.3,2.6,8.5c2.5,11.2,13.7,18.2,24.9,15.4c10.7-2.7,17.8-13.4,14.7-25 C164.1,381.2,148.9,375.4,137.1,382.6z M147.9,411.8c-6.6,0-12.1-5.4-12.1-12.1c0-6.7,11.2-11.8,11.2-11.8c0.5-0.2,1.4-0.3,1.9,0 c0,0,11,4.5,11.3,11.5C160.5,406.1,155,411.8,147.9,411.8z"/><path class="st0" d="M474.8,429.9h-14.2c-0.6,0-1.1,0.5-1.1,1.1v24.4c0,0.6,0.5,1.1,1.1,1.1h14.2c0.6,0,1.1-0.5,1.1-1.1V431 C475.9,430.4,475.4,429.9,474.8,429.9z"/><path class="st0" d="M474.9,202.6h-240c-0.6,0-1.1,0.5-1.1,1.1v12.1c0,0.6,0.5,1.1,1.1,1.1h240c0.6,0,1.1-0.5,1.1-1.1v-12.1 C476,203.1,475.5,202.6,474.9,202.6z"/><path class="st0" d="M474.9,254.8h-240c-0.6,0-1.1,0.5-1.1,1.1V268c0,0.6,0.5,1.1,1.1,1.1h240c0.6,0,1.1-0.5,1.1-1.1v-12.1 C476,255.3,475.5,254.8,474.9,254.8z"/><path class="st0" d="M474.9,151.7H367.9c-0.6,0-1.1,0.5-1.1,1.1v12.1c0,0.6,0.5,1.1,1.1,1.1h106.9c0.6,0,1.1-0.5,1.1-1.1v-12.1 C476,152.2,475.5,151.7,474.9,151.7z"/><path class="st0" d="M179.1,385.9c0,0,4.2-3.5,6.7-5.5c2.5-2,5-3.8,7.5-5.6c1-0.7,1.3-1.4,1.3-2.6c0-18.6,0-37.1,0-55.7 c0-0.6,0-0.7,0-0.7c-0.1-0.6-0.6-1.1-1.2-1.1h-14c-0.6,0-1.1,0.5-1.1,1.1v69.6C178.3,386.1,178.7,386.3,179.1,385.9z"/><path class="st0" d="M248.7,429.9h-14.2c-0.6,0-1.1,0.5-1.1,1.1v24.4c0,0.6,0.5,1.1,1.1,1.1h14.2c0.6,0,1.1-0.5,1.1-1.1V431 C249.7,430.4,249.2,429.9,248.7,429.9z"/><path class="st0" d="M194.1,394.3c-0.1,0-0.5,0.3-1,0.7c0,0-9.1,7.2-14.1,11.1c-0.4,0.3-0.5,0.5-0.5,0.5c-0.2,0.6-0.3,1.5-0.3,2.1 c0,0-0.1,3.5,0,5.7c0.1,3.3,2.6,5.6,6,5.7c1.6,0,3.1,0,4.7,0c2.9-0.1,5.5-2.3,5.6-5.2c0.1-6.9,0-19.8,0-19.8 C194.5,394.6,194.1,394.3,194.1,394.3z"/><path class="st0" d="M193.8,377.6c0,0-7.4,6.1-11.6,8.9c-3.2,2.1-4.5,4.6-4.1,8.3c0.3,2.7,0.1,7.4,0.1,7.4c0,0.6,0.1,1,0.2,1 c0.2,0,0.8-0.5,1.2-0.8l13.4-10.6c0.5-0.4,1-0.8,1.1-1c0.2-0.2,0.3-1.2,0.3-1.8l0-11C194.6,377.4,194.3,377.2,193.8,377.6z"/><path class="st0" d="M315.7,341.8c0.3,0.5,0.1,1-0.4,1.1l-18.7,4c-0.6,0.1-0.7,0.6-0.3,1l43.6,48.3c0.4,0.4,0.9,0.3,1-0.2l20-61.9 c0.2-0.6-0.1-0.9-0.7-0.8l-20,4.3c-0.6,0.1-1.3-0.2-1.6-0.7c0,0-13.7-22.6-23.7-32.6c-21.4-21.4-52.2-34.2-84.3-35 c-34.3-0.7-66.5,11.9-90.5,35.8c-4.4,4.4-4.4,11.5,0,15.9c4.4,4.4,11.5,4.4,15.9,0c19.6-19.6,45.7-29.8,74-29.2 c26.5,0.7,51.6,11,69,28.4C305.9,327,315.7,341.8,315.7,341.8z"/><path class="st0" d="M234.9,319.2h37.5c0.6,0,1.1-0.5,1.1-1.1v-12.1c0-0.6-0.5-1.1-1.1-1.1h-37.5c-0.6,0-1.1,0.5-1.1,1.1v12.1 C233.8,318.7,234.3,319.2,234.9,319.2z"/><path class="st0" d="M233.8,369.7c0,0.6,0.5,1.1,1.1,1.1h57.3c0.6,0,1.1-0.5,1.1-1.1v-12.1c0-0.6-0.5-1.1-1.1-1.1h-57.3 c-0.6,0-1.1,0.5-1.1,1.1V369.7z"/></g><g id="cart-sterilisation"><path class="st0" d="M426.6,494.2c4.2,12.5,17.8,19.2,30.2,14.9c12.4-4.2,19.1-17.8,14.9-30.2c-3.4-9.9-12.6-16.1-22.5-16.1c-2.6,0-5.1,0.4-7.7,1.3C429,468.2,422.3,481.8,426.6,494.2 M135.7,478.9c-4.2,12.5,2.4,26.1,14.9,30.2c12.5,4.2,26-2.5,30.3-14.9c4.2-12.5-2.5-26-15-30.2c-2.5-0.9-5.1-1.3-7.7-1.3C148.3,462.8,139,469,135.7,478.9 M320.4,353.4h-28.5v12h28.5V353.4z M173.6,142.9h28.5v-12h-28.5V142.9z M173.6,251.2h28.5v-12h-28.5V251.2z M173.6,365.4h28.5v-12h-28.5V365.4z M291.9,142.9h28.5v-12h-28.5V142.9z M291.9,251.2h28.5v-12h-28.5V251.2z M410.2,142.9h28.5v-12h-28.5V142.9z M410.2,251.2h28.5v-12h-28.5V251.2z M410.2,365.4h28.5v-12h-28.5V365.4z M473,423.5c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V423.5z M473,338.9c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V338.9z M473,309.3c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V309.3z M473,224.8c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V224.8z M473,199.1c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V199.1z M473,114.6c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V114.6z M354.7,309.3c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V309.3z M354.7,199.1c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V199.1z M354.7,114.6c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V114.6z M236.4,423.5c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V423.5z M236.4,338.9c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V338.9z M236.4,309.3c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V309.3z M236.4,224.8c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V224.8z M236.4,199.1c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-78.9c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V199.1z M236.4,114.6c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4v-11.1c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4V114.6z M257.6,213.6c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4v11.1c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4V213.6z M257.6,327.8c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4v11.1c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4V327.8z M257.6,344.6c0-0.2,0.2-0.4,0.4-0.4h96.2c0.2,0,0.4,0.2,0.4,0.4v78.9c0,0.2-0.2,0.4-0.4,0.4h-96.2c-0.2,0-0.4-0.2-0.4-0.4V344.6z M505,451.5V82.4c0-0.6-0.5-1.2-1.2-1.2h-399c-0.6,0-1.2,0.5-1.2,1.2v369.2c0,0.6,0.5,1.2,1.2,1.2h399C504.5,452.7,505,452.2,505,451.5"/></g><g id="cart-sterilisation-autoclave"><path class="st0" d="M355.7,162.7V71.6c0-0.4-0.3-0.6-0.6-0.6H181.8c-0.4,0-0.6,0.3-0.6,0.6v91.1c0,0.4,0.3,0.6,0.6,0.6H355C355.4,163.3,355.7,163,355.7,162.7 M355.7,266.7v-91.1c0-0.4-0.3-0.6-0.6-0.6H181.8c-0.4,0-0.6,0.3-0.6,0.6v91.1c0,0.4,0.3,0.6,0.6,0.6H355C355.4,267.3,355.7,267,355.7,266.7 M410.9,203c0,4.5,3.6,8.1,8.1,8.1c4.5,0,8.1-3.6,8.1-8.1s-3.6-8.1-8.1-8.1C414.5,195,410.9,198.6,410.9,203 M392.6,203c0,4.5,3.6,8.1,8.1,8.1c4.5,0,8.1-3.6,8.1-8.1s-3.6-8.1-8.1-8.1C396.2,195,392.6,198.6,392.6,203 M445,103.6v-32c0-0.4-0.3-0.6-0.6-0.6h-51.1c-0.4,0-0.6,0.3-0.6,0.6v32c0,0.4,0.3,0.6,0.6,0.6h51.1C444.7,104.2,445,103.9,445,103.6 M446,203c0-4.5-3.6-8.1-8.1-8.1c-4.5,0-8.1,3.6-8.1,8.1s3.6,8.1,8.1,8.1C442.3,211.1,446,207.5,446,203 M450.7,222.7c0,0.4-0.3,0.6-0.6,0.6h-61.3c-0.4,0-0.6-0.3-0.6-0.6V58.2c0-0.4,0.3-0.6,0.6-0.6h61.3c0.4,0,0.6,0.3,0.6,0.6V222.7z M369.2,280.5c0,0.4-0.3,0.6-0.6,0.6H169.9c-0.4,0-0.6-0.3-0.6-0.6V58.2c0-0.4,0.3-0.6,0.6-0.6h198.7c0.4,0,0.6,0.3,0.6,0.6V280.5z M472.4,569.5V26.8c0-0.4-0.3-0.6-0.6-0.6H148.6c-0.4,0-0.6,0.3-0.6,0.6v542.7c0,0.4,0.3,0.6,0.6,0.6h323.1C472.1,570.2,472.4,569.9,472.4,569.5"/></g><g id="cart-sterilisation-wash"><path class="st0" d="M310,161.3v13.5c0,1.8,1.4,3.2,3.2,3.2h25c1.8,0,3.2-1.4,3.2-3.2v-13.5c0-1.8-1.4-3.2-3.2-3.2h-25 C311.4,158.2,310,159.6,310,161.3 M179.8,263.5c0,1.8,1.6,3.3,3.5,3.3h105.8c1.9,0,3.5-1.5,3.5-3.3c0-1.8-1.6-3.3-3.5-3.3H183.3 C181.4,260.2,179.8,261.7,179.8,263.5 M179.8,239.5c0,1.8,1.6,3.3,3.5,3.3h105.8c1.9,0,3.5-1.5,3.5-3.3c0-1.8-1.6-3.3-3.5-3.3 H183.3C181.4,236.2,179.8,237.7,179.8,239.5 M179.8,216.1c0,1.8,1.6,3.3,3.5,3.3h105.8c1.9,0,3.5-1.5,3.5-3.3 c0-1.8-1.6-3.3-3.5-3.3H183.3C181.4,212.8,179.8,214.3,179.8,216.1 M179.8,191.8c0,1.8,1.6,3.3,3.5,3.3h105.8 c1.9,0,3.5-1.5,3.5-3.3s-1.6-3.3-3.5-3.3H183.3C181.4,188.5,179.8,190,179.8,191.8 M179.8,168.1c0,1.8,1.6,3.3,3.5,3.3h105.8 c1.9,0,3.5-1.5,3.5-3.3c0-1.8-1.6-3.3-3.5-3.3H183.3C181.4,164.8,179.8,166.3,179.8,168.1 M176.5,140.9c0-1.8,1.4-3.2,3.2-3.2 h113.2c1.8,0,3.2,1.4,3.2,3.2v147.3c0,1.7-1.4,3.2-3.2,3.2H179.7c-1.8,0-3.2-1.4-3.2-3.2V140.9z M344.7,288.1 c0,1.7-1.4,3.2-3.2,3.2h-31c-1.8,0-3.2-1.4-3.2-3.2V140.9c0-1.8,1.4-3.2,3.2-3.2h31c1.8,0,3.2,1.4,3.2,3.2 M163.8,124.9v343 c0,1.8,1.4,3.2,3.2,3.2h187.5c1.8,0,3.2-1.4,3.2-3.2v-343c0-1.8-1.4-3.2-3.2-3.2H166.9C165.2,121.7,163.8,123.1,163.8,124.9 M357.7,114.6V38.4c0-1.8-1.4-3.2-3.2-3.2H166.9c-1.7,0-3.2,1.4-3.2,3.2v76.3c0,1.8,1.4,3.2,3.2,3.2h187.5 C356.2,117.8,357.7,116.4,357.7,114.6"/></g><g id="manual-washing"><path d="M207.3,159.9c-0.8,0.9-1.1,1.4-1.6,1.9c-10.3,10.3-20.7,20.7-31,31c-11.4,11.4-22.8,22.8-34.2,34.2c-7.9,7.9-5,21,5.3,24.5c5.9,2,11.3,0.6,15.7-3.9c14.5-14.5,29-29,43.5-43.4c0.7-0.7,1.3-1.7,2.1-1.9c1-0.3,2.7-0.5,3.3,0.1c0.6,0.6,0.4,2.2,0.2,3.3c-0.1,0.6-0.9,1-1.4,1.5c-16.2,16.2-32.4,32.5-48.7,48.7c-1.5,1.5-3.1,3-4.5,4.6c-7.2,8.4-3,21.5,7.8,23.9c5.5,1.2,10.3-0.5,14.3-4.5c17.4-17.5,34.9-34.9,52.4-52.4c1.8-1.8,3.4-2.1,4.5-0.8c1.4,1.7,0.5,3-0.8,4.3c-4.7,4.7-9.4,9.4-14.2,14.1c-11.2,11.2-22.4,22.3-33.5,33.5c-7.3,7.4-5.5,19.2,3.4,23.8c5.9,3,12.6,1.8,17.7-3.3c15.6-15.6,31.2-31.2,46.8-46.8c0.6-0.6,1.2-1.5,2-1.7c0.9-0.2,2.3-0.2,2.8,0.3c0.6,0.6,0.7,2,0.5,2.9c-0.1,0.7-0.9,1.2-1.5,1.8c-8.3,8.3-16.6,16.6-24.9,24.9c-4,4-5.4,8.7-4.2,14.2c1.3,5.5,4.8,9.1,10.2,10.6c5.9,1.6,10.9-0.1,15.2-4.3c26.3-26.3,52.7-52.4,78.7-78.9c11.5-11.7,17.5-26.4,18.7-42.7c0.5-6.6-1.5-12.3-6.5-17.2c-16-15.7-31.7-31.6-47.5-47.4c-6.3-6.4-14-10-22.8-11.3c-11-1.6-21.8-0.1-32.5,2.6c-17.8,4.5-34.6,12-51.2,19.6c-14,6.4-28,12.8-42.1,18.9c-7.5,3.2-11.7,10.8-9.4,18.2c2.3,7.5,10,11.6,18,9.6c10.8-2.7,21.7-5.5,32.5-8.2C195.8,162.7,201.2,161.4,207.3,159.9z M152,198.1c-18-16.8-48.9-18.6-70.2-4c-3.8,2.6-7.4,5.4-11.1,8.2c-6.9,5.2-14.7,7.5-23.3,7.4c-2.1,0-3-0.8-3.6-2.7c-4.6-13.4-9.3-26.8-14-40.2c-0.3-0.9-0.6-1.7-1-2.7c-6.5,2.3-12.6,4.4-18.8,6.6c0.3,0.9,0.5,1.6,0.7,2.2C36.4,246.3,62,319.7,87.6,393.1c0.7,2.1,1.8,2.4,3.8,2.4c101.7,0,203.3,0,305,0c2.3,0,3.4-0.6,4.2-2.9c24-68.9,48.1-137.8,72.1-206.6c1.8-5,3.5-10.1,5.3-15.3c-6.4-2.2-12.6-4.4-18.9-6.6c-5.4,15.4-10.7,30.4-15.9,45.4c-6.7,0.1-13.1-2-19.3-6.3c-3.4-2.4-6.7-4.9-10-7.4c-13-9.8-27.7-13-43.7-11c-1.9,0.2-2.8,0.9-3.1,2.9c-0.6,3.3-1.6,6.6-2.7,9.7c-1.4,3.9-3.1,7.8-4.6,11.6c15.5-7.3,30.2-6.7,43.8,4.1c9.7,7.7,19.7,14.4,32.6,15.9c-0.3,1.2-0.6,2.1-0.9,2.9c-16.4,46.9-32.8,93.8-49.1,140.7c-0.7,2-1.5,2.8-3.8,2.8c-92.2-0.1-184.4-0.1-276.6,0c-2.5,0-3.4-0.9-4.1-3c-16.2-46.7-32.6-93.3-48.9-140c-0.3-0.9-0.5-1.8-0.9-2.8c0.8-0.1,1.3-0.2,1.8-0.3c9.3-0.7,17.8-3.5,25.5-8.7c3.7-2.5,7.4-5.1,10.9-8c13.8-11.5,34.7-10.8,46.8-1.1c0.3,0.3,0.7,0.4,1,0.6C142.7,207.5,147.3,202.9,152,198.1z"/></g><g id="ddt"><path d="M445.3,434.9c0,21-16.9,37.9-37.9,37.9H89.2c-21,0-37.9-16.9-37.9-37.9V56.1c0-21,16.9-37.9,37.9-37.9h318.2c21,0,37.9,16.9,37.9,37.9V434.9z M415,3H81.6C56.4,3,36.1,23.4,36.1,48.5v394c0,25.1,20.4,45.5,45.5,45.5h333.5c25.1,0,45.5-20.3,45.5-45.5v-394C460.5,23.4,440.2,3,415,3"/><path d="M407.4,186.2H89.2c-4.1,0-7.6,3.5-7.6,7.6c0,4.1,3.3,7.6,7.6,7.6h318.2c4.1,0,7.6-3.3,7.6-7.6S411.6,186.2,407.4,186.2"/><path d="M407.4,231.6H89.2c-4.1,0-7.6,3.3-7.6,7.6c0,4.1,3.3,7.6,7.6,7.6h318.2c4.1,0,7.6-3.5,7.6-7.6C415,235,411.6,231.6,407.4,231.6"/><path d="M407.4,277.1H89.2c-4.1,0-7.6,3.5-7.6,7.6c0,4.1,3.3,7.6,7.6,7.6h318.2c4.1,0,7.6-3.3,7.6-7.6C415,280.5,411.6,277.1,407.4,277.1"/><path d="M407.4,322.5H89.2c-4.1,0-7.6,3.3-7.6,7.6c0,4.1,3.3,7.6,7.6,7.6h318.2c4.1,0,7.6-3.5,7.6-7.6C415,325.9,411.6,322.5,407.4,322.5"/><path d="M286.2,368h-197c-4.1,0-7.6,3.5-7.6,7.6c0,4.1,3.3,7.6,7.6,7.6h197c4.1,0,7.6-3.5,7.6-7.6C293.8,371.4,290.3,368,286.2,368"/><path d="M377.2,427.3c-12.6,0-22.7-10.1-22.7-22.7c0-12.6,10.1-22.7,22.7-22.7c12.6,0,22.7,10.1,22.7,22.7C399.9,417.2,389.7,427.3,377.2,427.3 M377.2,366.8c-21,0-37.9,16.9-37.9,37.9s16.9,37.9,37.9,37.9s37.9-16.9,37.9-37.9C415,383.8,398,366.8,377.2,366.8"/><path d="M253.2,131.2h13.7V68.8h24.6V57.3h-63v11.5h24.6L253.2,131.2L253.2,131.2z M173.5,119.6V68.8h11.3c15.1,0,25,8.8,25,25.3c0,16.6-9.7,25.5-25,25.5L173.5,119.6L173.5,119.6z M159.9,131.2h25.6c23.2,0,38.4-13.7,38.4-37.1s-15.2-36.9-38.4-36.9h-25.6V131.2z M95.2,119.6V68.8h11.3c15.1,0,25,8.8,25,25.3c0,16.6-9.7,25.5-25,25.5L95.2,119.6L95.2,119.6z M81.6,131.2h25.6c23.2,0,38.4-13.7,38.4-37.1s-15.2-36.9-38.4-36.9H81.6C81.6,57.2,81.6,131.2,81.6,131.2z"/></g></defs></svg></iron-iconset-svg>',document.head.appendChild(r.content)},
/***/Vp5t:
/***/function(c,t,o){"use strict";
/* unused harmony export returndtmultipleListStyles */
/* harmony import */o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }
  .counter {
    margin-top: 0px;
  }
`
/***/},
/***/WAxR:
/***/function(c,t,o){"use strict";
/* unused harmony export invoicingListViewStyles */
/* harmony import */o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }

  .select-all {
    margin: 0px;
    padding: 0px 0px 0px 2px;
    width: 8%;
  }
`
/***/},
/***/XcjL:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/ZyhH:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }
`
/***/},
/***/cS5R:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }
  .counter {
    margin-top: 0px;
  }
`
/***/},
/***/cb0m:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/"h+sf":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return i}));
/* harmony import */var r=o("Rukz");const i=()=>r.d`
  <dom-module id="custom-style" theme-for="vaadin-text-field vaadin-number-field vaadin-password-field vaadin-email-field vaadin-text-area">
    <template>
      <style>
        :host(.custom-style) [part='input-field'] {
          border: 1px solid #ccc;
          background-color: #fff;
          height: 36px;
        }

        :host([focused].custom-style) [part='input-field'] {
          border-color: #00ffff;
        }

        :host(.custom-style) {
          padding-top: 0px;
        }

        :host([has-label].custom-style) {
          padding-top: 0px;
        }

        [part='input-field'] {
          border: 1px solid gray;
        }

        :host(vaadin-text-area) [part='input-field'] {
          line-height: 20px !important;
        }

        [part='input-field'] {
          border-radius: var(--lumo-border-radius);
          background-color: #fff !important;
          padding: 0 calc(0.375em + var(--lumo-border-radius) / 4 - 1px);
          font-weight: 500;
          line-height: 1;
          position: relative;
          cursor: text;
          box-sizing: border-box;
          font-size: 13px;
        }
      </style>
    </template>
  </dom-module>

  <!-- <dom-module id="custom-style-disabled" theme-for="vaadin-combo-box vaadin-text-field vaadin-number-field vaadin-password-field vaadin-email-field vaadin-text-area">
            <template>
                <style>
                    :host([disabled]) [part="label"], :host([disabled]) [part="value"], :host([disabled]) [part="input-field"] ::slotted(*) {
                        color: #475C7B !important;
                        -webkit-text-fill-color: #475C7B !important;

                    }
                </style>
            </template>
        </dom-module> -->

  <dom-module id="custom-combo-box" theme-for="vaadin-combo-box">
    <template>
      <style>
        :host([theme~='custom']) {
          padding-top: 0px !important;
          padding: 0px !important;
          margin: 0px !important;
        }

        :host([part='value']) {
          padding-top: 0px !important;
          padding: 0px !important;
          margin: 0px !important;
          font-size: 11px !important;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-text-field-and-item" theme-for="vaadin-text-field vaadin-number-field vaadin-password-field vaadin-email-field vaadin-combo-box-item">
    <template>
      <style>
        :host([theme~='custom']) {
          color: #333;
          margin: 0px !important;
          padding: 0px !important;
          font-size: 13px;
        }

        label[part='label'] {
          font-size: 12px;
          color: #878787 !important;
          font-weight: normal;
          height: 22px;
          line-height: 22px;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-style" theme-for="vaadin-accordion vaadin-accordion-panel">
    <template>
      <style>
        :host {
          margin: 0px;
          padding: 0px;
        }

        [part='summary'] {
          display: inherit !important;
          align-items: center;
          width: 100%;
          outline: none;
          padding: 0px !important;
          margin: 0px !important;

          box-sizing: border-box;
          font-family: var(--lumo-font-family);
          font-size: var(--lumo-font-size-m);
          font-weight: 500;
          line-height: var(--lumo-line-height-xs);
          color: var(--lumo-secondary-text-color);
          background-color: inherit;
          border-radius: var(--lumo-border-radius-m);
          cursor: default;
          -webkit-tap-highlight-color: transparent;
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        [part='content'] {
          padding: 0px !important;
          margin: 0px !important;
          font-size: var(--lumo-font-size-m);
          line-height: var(--lumo-line-height-m);
        }

        [part='input-field'] {
          border-radius: var(--lumo-border-radius);
          background-color: #fff !important;
          padding: 0 calc(0.375em + var(--lumo-border-radius) / 4 - 1px);
          font-weight: 500;
          line-height: 1;
          position: relative;
          cursor: text;
          box-sizing: border-box;
          font-size: 13px;
        }

        [part='toggle'] {
          display: block;
          width: 1em;
          height: 1em;
          margin-left: calc(var(--lumo-space-xs) * -1);
          margin-right: var(--lumo-space-xs);
          font-size: var(--lumo-icon-size-s);
          line-height: 1;
          color: #475c7b !important;
          font-family: 'lumo-icons';
          position: absolute !important;
          right: 10px !important;
          top: 8px !important;
          background-color: transparent !important;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-combo-box-input" theme-for="vaadin-text-field vaadin-text-area">
    <template>
      <style>
        :host([theme~='custom']) [part='input-field'] {
          border: 1px solid #ccc;
          background-color: #fff;
          height: 30px;
          font-size: 14px;
          line-height: 20px;
        }

        :host([theme~='small']) [part='input-field'] {
          border: 1px solid #ccc;
          background-color: #fff;
          height: 30px;
          font-size: 14px;
          margin: 0px !important;
          padding: 0px !important;
        }

        :host([theme~='small']) input {
          padding: 0px !important;
          padding-left: 5px !important;
          margin: 0px !important;
          height: 24px;
          line-height: 24px;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-combo-box-overlay" theme-for="">
    <template>
      <style>
        vaadin-combo-box-overlay:host([theme~='custom']) [part='overlay'] {
          background-color: #333;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-style-barcode" theme-for="vaadin-text-field vaadin-text-area vaadin-number-field vaadin-password-field vaadin-email-field">
    <template>
      <style>
        :host(.custom-style-barcode) [part='input-field'] {
          border: 1px solid #ccc;
          background-color: #fff;
          height: 30px;
          float: left;
        }

        .vaadin-text-field-container {
          display: flex;
          flex-direction: column;
          width: calc(100% - 90px);
          float: left;
        }

        :host([focused].custom-style-barcode) [part='input-field'] {
          border-color: #333;
        }

        :host(.custom-style-barcode) {
          padding-top: 0px;
        }

        :host([has-label].custom-style-barcode) {
          padding-top: 0px;
        }

        [part='input-field'] {
          border: 1px solid #ccc;
          background-color: #fff;
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          border-radius: 4px 4px;
        }

        :host(vaadin-text-area) [part='input-field'] {
          border: 1px solid #ccc;
          background-color: #fff;
          padding: 6px;
          font-size: 14px;
          border-radius: 4px 0px 0px 4px;
        }

        :host(vaadin-text-field.custom-style-barcode) [part='input-field'] {
          border: 1px solid #ccc;
          background-color: rgba(255, 243, 205, 0.5);
          height: 30px;
          line-height: 30px;
          font-size: 14px;
          border-radius: 4px 0px 0px 4px;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-notification-card-style" theme-for="vaadin-notification-card">
    <template>
      <style>
        :host([theme~='error']) [part='overlay'] {
          background: #ed5565;
        }

        :host([theme~='warning']) [part='overlay'] {
          background: #e8dc58;
        }
        :host([theme~='success']) [part='overlay'] {
          background: #5cb85c;
        }
      </style>
    </template>
  </dom-module>

  <dom-module id="custom-upload-style" theme-for="vaadin-upload">
    <template>
      <style>
        :host([disabled]) [part='primary-buttons'] vaadin-button[part='upload-button'] {
          opacity: 0.5;
          cursor: not-allowed;
        }
      </style>
    </template>
  </dom-module>
`
/***/},
/***/i7JO:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .page {
    display: none;
  }

  .page[active] {
    display: block;
  }
`
/***/},
/***/jH8t:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/o0We:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }
`
/***/},
/***/q0jl:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hide {
    display: none;
  }
  .show {
    display: block;
  }
`
/***/},
/***/"rE+7":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }

  #productsidebar .form-group {
    margin-bottom: 10px !important;
  }
`
/***/},
/***/rdqd:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  :host {
    display: block;
    box-sizing: border-box;
  }

  section {
    padding: 24px;
    background: var(--app-section-odd-color);
  }

  section > * {
    max-width: 600px;
    margin-right: auto;
    margin-left: auto;
  }

  section:nth-of-type(even) {
    background: var(--app-section-even-color);
  }

  h2 {
    font-size: 24px;
    text-align: center;
    color: var(--app-dark-text-color);
  }

  @media (min-width: 460px) {
    h2 {
      font-size: 36px;
    }
  }

  .circle {
    display: block;
    width: 64px;
    height: 64px;
    margin: 0 auto;
    text-align: center;
    border-radius: 50%;
    background: var(--app-primary-color);
    color: var(--app-light-text-color);
    font-size: 30px;
    line-height: 64px;
  }

  paper-button {
    padding: 8px 16px;
    border-radius: 3px;
    font-size: 15px;
  }

  paper-button.small {
    padding: 5px;
    height: 26px;
  }

  paper-button.green {
    border: 1px solid hsl(122, 39%, 49%);
    background-color: hsl(122, 39%, 49%);
    color: #ffffff;
    --paper-button-raised-keyboard-focus: {
      background-color: hsl(122, 39%, 59%) !important;
      color: white !important;
    }
  }

  paper-button.green:hover {
    background-color: hsl(122, 39%, 54%);
  }

  paper-button.blue {
    background-color: #2c4a61;
    color: white;

    --paper-button-raised-keyboard-focus: {
      background-color: #448aff !important;
      color: white !important;
    }
  }

  paper-button.blue:hover {
    background-color: #385c77;
  }

  .topbar {
    padding: 15px 0px 15px 0px;
    background-color: #fff;
    margin-bottom: 20px;
    padding-bottom: 9px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .list-six-elements-sidebar-small {
    margin: 0px;
    padding: 0px;
    height: 370px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 40px;
  }

  .list-six-elements-sidebar {
    margin: 0px;
    padding: 0px;
    height: 520px;
    overflow-y: scroll;
    overflow-x: hidden;
    margin-top: 40px;
  }
  .list-six-elements-sidebar-item {
    height: 26px;
    line-height: 26px;
    font-size: 15px;
  }

  .list-six-elements-sidebar-item six-button {
    margin-top: 5px;
  }

  .list-six-elements {
    margin: 0px;
    padding: 0px;
    max-height: 530px;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .list-six-elements.one-row {
    height: 34px !important;
  }
  .list-six-elements.two-row {
    height: 68px !important;
  }
  .list-six-elements.three-row {
    height: 102px !important;
  }
  .list-six-elements.four-row {
    height: 136px !important;
  }
  .list-six-elements.five-row {
    height: 170px !important;
  }
  .list-six-elements.six-row {
    height: 204px !important;
  }
  .list-six-elements.seven-row {
    height: 238px !important;
  }

  .list-six-elements.eight-row {
    height: 272px !important;
  }

  .list-six-elements.nine-row {
    height: 306px !important;
  }

  .list-six-elements.ten-row {
    height: 340px !important;
  }

  .list-six-elements.eleven-row {
    height: 374px !important;
  }

  .list-six-elements.twelve-row {
    height: 408px !important;
  }

  .list-six-elements.thirteen-row {
    height: 480px !important;
  }

  .list-six-elements.fourteen-row {
    height: 570 !important;
  }

  .m-xxs {
    margin: 2px 4px;
  }

  .m-xs {
    margin: 5px;
  }

  .m-sm {
    margin: 10px;
  }

  .m {
    margin: 15px;
  }

  .m-md {
    margin: 20px;
  }

  .m-lg {
    margin: 30px;
  }

  .m-xl {
    margin: 50px;
  }

  .m-n {
    margin: 0 !important;
  }

  .m-l-none {
    margin-left: 0 !important;
  }

  .m-l-xs {
    margin-left: 5px;
  }

  .m-l-sm {
    margin-left: 10px;
  }

  .m-l {
    margin-left: 15px;
  }

  .m-l-md {
    margin-left: 20px;
  }

  .m-l-lg {
    margin-left: 30px;
  }

  .m-l-xl {
    margin-left: 40px;
  }

  .m-l-xxl {
    margin-left: 50px;
  }

  .m-l-n-xxs {
    margin-left: -1px;
  }

  .m-l-n-xs {
    margin-left: -5px;
  }

  .m-l-n-sm {
    margin-left: -10px;
  }

  .m-l-n {
    margin-left: -15px;
  }

  .m-l-n-md {
    margin-left: -20px;
  }

  .m-l-n-lg {
    margin-left: -30px;
  }

  .m-l-n-xl {
    margin-left: -40px;
  }

  .m-l-n-xxl {
    margin-left: -50px;
  }

  .m-t-none {
    margin-top: 0 !important;
  }

  .m-t-xxs {
    margin-top: 1px;
  }

  .m-t-xs {
    margin-top: 5px;
  }

  .m-t-sm {
    margin-top: 10px;
  }

  .m-t {
    margin-top: 15px;
  }

  .m-t-md {
    margin-top: 20px;
  }

  .m-t-lg {
    margin-top: 30px;
  }

  .m-t-xl {
    margin-top: 40px;
  }

  .m-t-xxl {
    margin-top: 50px;
  }

  .m-t-toolbar {
    margin-top: 70px;
  }

  .m-t-n-xxs {
    margin-top: -1px;
  }

  .m-t-n-xs {
    margin-top: -5px;
  }

  .m-t-n-sm {
    margin-top: -10px;
  }

  .m-t-n {
    margin-top: -15px;
  }

  .m-t-n-md {
    margin-top: -20px;
  }

  .m-t-n-lg {
    margin-top: -30px;
  }

  .m-t-n-xl {
    margin-top: -40px;
  }

  .m-t-n-xxl {
    margin-top: -50px;
  }

  .m-r-none {
    margin-right: 0 !important;
  }

  .m-r-xxs {
    margin-right: 1px;
  }

  .m-r-xs {
    margin-right: 5px;
  }

  .m-r-sm {
    margin-right: 10px;
  }

  .m-r {
    margin-right: 15px;
  }

  .m-r-md {
    margin-right: 20px;
  }

  .m-r-lg {
    margin-right: 30px;
  }

  .m-r-xl {
    margin-right: 40px;
  }

  .m-r-xxl {
    margin-right: 50px;
  }

  .m-r-n-xxs {
    margin-right: -1px;
  }

  .m-r-n-xs {
    margin-right: -5px;
  }

  .m-r-n-sm {
    margin-right: -10px;
  }

  .m-r-n {
    margin-right: -15px;
  }

  .m-r-n-md {
    margin-right: -20px;
  }

  .m-r-n-lg {
    margin-right: -30px;
  }

  .m-r-n-xl {
    margin-right: -40px;
  }

  .m-r-n-xxl {
    margin-right: -50px;
  }

  .m-b-none {
    margin-bottom: 0 !important;
  }

  .m-b-xxs {
    margin-bottom: 1px;
  }

  .m-b-xs {
    margin-bottom: 5px;
  }

  .m-b-sm {
    margin-bottom: 10px;
  }

  .m-b {
    margin-bottom: 15px;
  }

  .m-b-md {
    margin-bottom: 20px;
  }

  .m-b-lg {
    margin-bottom: 30px;
  }

  .m-b-xl {
    margin-bottom: 40px;
  }

  .m-b-xxl {
    margin-bottom: 50px;
  }

  .m-b-n-xxs {
    margin-bottom: -1px;
  }

  .m-b-n-xs {
    margin-bottom: -5px;
  }

  .m-b-n-sm {
    margin-bottom: -10px;
  }

  .m-b-n {
    margin-bottom: -15px;
  }

  .m-b-n-md {
    margin-bottom: -20px;
  }

  .m-b-n-lg {
    margin-bottom: -30px;
  }

  .m-b-n-xl {
    margin-bottom: -40px;
  }

  .m-b-n-xxl {
    margin-bottom: -50px;
  }

  iron-icon {
    margin-right: 0px;
  }

  .menu-wrapper {
    padding: 0px 0px 20px 0px;
  }

  .menu {
    display: block;
    margin: 0px;
    padding: 0px;

    text-align: center;
  }

  .menu ul {
    list-style: none;
    width: 100%;
    display: table;
    text-align: center;
  }

  .menu li {
    list-style-type: none;
    display: inline-block;
    float: none;
    border-radius: 25px;
    margin: 0px 5px;
    position: relative;
    background: #fff;
    z-index: 100000;
    height: 34px;
    line-height: 34px;
  }

  .menu li.line {
    list-style-type: none;
    display: inline;
    border-radius: 0px;
    border-bottom: 1px solid rgba(71, 92, 123, 0.7);
    margin: 0px;
    width: 50px;
    position: absolute;
    /* left: 0px; */
    top: 15px;
    margin-left: -27px;
    z-index: 10;
    height: 1px;
  }

  .menu li a {
    font-weight: 600;
    text-decoration: none;
    padding: 0px 15px 0px 15px;
    display: block;
    color: rgb(71, 92, 123);
    float: none;
    font-size: 14px;
    height: 34px;
    line-height: 34px;
    border-radius: 3px;

    transition: all 0.2s ease-in-out 0s;
  }

  .menu li a span.number {
    background-color: rgba(71, 92, 123, 0.2);
    padding: 7px 11px;
    border-radius: 3px 0px 0px 3px;
    color: rgb(71, 92, 123);
    height: 30px;
    width: 30px;
    line-height: 30px;
    margin-right: 8px;
    border-right: 1px solid rgba(71, 92, 123, 0.4);
  }

  .menu li.active a span.number {
    background-color: rgb(71, 92, 123);
    padding: 7px 11px;
    border-radius: 3px 0px 0px 3px;
    height: 30px;
    width: 30px;
    line-height: 30px;
    margin-right: 8px;
    border-right: 1px solid rgba(255, 255, 255, 0.3);

    color: #fff;
  }

  .menu li.active {
    background: rgba(71, 92, 123, 1);
    color: #fff !important;
    border-radius: 25px;
    border: 1px solid rgba(71, 92, 123, 0.7);
  }

  .menu li.not-active {
    border: 1px solid rgba(71, 92, 123, 0.7);
  }

  .menu li.active a {
    color: #fff !important;
  }

  .menu li.done {
    background-color: rgba(71, 92, 123, 0.1);
    color: rgba(71, 92, 123, 0.6) !important;
    border-radius: 3px;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }

  .menu li.done a {
    color: rgba(71, 92, 123, 0.6) !important;
    pointer-events: auto !important;
    cursor: not-allowed !important;
  }

  .menu li.done a span.number {
    background-color: rgb(92, 184, 92);
    padding: 7px 11px;
    border-radius: 3px 0px 0px 3px;
    height: 30px;
    width: 30px;
    line-height: 30px;
    margin-right: 8px;
    border-right: 1px solid rgba(255, 255, 255, 0.5);

    color: #fff;
  }

  .checkbox-wrapper {
    padding: 0px 0px;
    width: 100%;
    border-radius: 4px;
  }

  .checkbox-wrapper p {
    float: left;
    margin: 0px !important;
    margin-left: 7px;
  }

  .elements-item h3 {
    font-size: 13px;
    margin: 0px 0px;
    line-height: 30px;
  }

  .elements-item p {
    font-size: 12px;
    margin: 0px 0px;
    line-height: 30px;
  }

  .elements-item .date {
    font-size: 13px;
    margin: 0px 0px;
    line-height: 30px;
  }

  .thead-elements {
    height: 30px;
    line-height: 30px;
    margin: 0px;
    background: #d2ddec;
    margin-bottom: 10px;
    font-size: 12px;
    border-bottom: 3px solid #a9bad4;
    color: var(--app-primary-color);
    overflow: hidden;
    padding: 0px 10px 0px 0px;
  }

  .thead-elements p {
    font-size: 12px;
    color: var(--app-primary-color);
    margin: 0px;
  }

  .list-filter-wrapper .filter {
    float: left;
    margin-right: 8px;
    cursor: pointer;
  }

  .qty .count {
    color: #000;
    display: inline-block;
    vertical-align: top;
    font-size: 12px;
    line-height: 26px;
    height: 26px;
    padding: 0 10px;
    min-width: 55px;
    text-align: center;
    font-weight: 600;
    border: 1px solid #ccc;
    border-radius: 3px !important;
  }
  .qty .plus {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    color: white;
    width: 26px;
    height: 26px;
    text-align: center;
    border-radius: 3px;
    background-color: var(--app-success-color);
  }
  .qty .minus {
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    color: white;
    width: 26px;
    height: 26px;
    text-align: center;
    border-radius: 3px;
    background-clip: padding-box;
    background-color: var(--app-primary-color);
  }

  .minus:hover {
    background-color: #999999 !important;
  }
  .plus:hover {
    background-color: #999999 !important;
  }
  /*Prevent text selection*/
  span {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
  }
  input {
    border: 0;
    width: 2%;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input:disabled {
    background-color: white;
  }

  .progress-wrapper {
    margin-bottom: 5px;
    margin-top: 2px;
  }

  .progress-wrapper .progress {
    display: -ms-flexbox;
    display: flex;
    height: 10px;
    overflow: hidden;
    font-size: 0.703125rem;
    background-color: #e9ecef;
    border-radius: 3px;
    padding-bottom: 0px;
    margin-bottom: 0px;
  }

  .progress-wrapper p {
    font-size: 12px;
    padding-bottom: 0px;
    margin: 0px;
    margin-bottom: 2px;
    color: var(--app-primary-color);
    font-weight: 600;
  }

  .progress-wrapper .progress-bar {
    color: #fff;
    text-align: center;
    transition: width 0.6s ease;
  }

  .progress-wrapper .bg-blue {
    background-color: var(--app-primary-color) !important;
  }

  .progress-wrapper .progress-bar-striped {
    background-image: linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.15) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.15) 50%,
      rgba(255, 255, 255, 0.15) 75%,
      transparent 75%,
      transparent
    );
    background-size: 1rem 1rem;
  }

  .progress-wrapper .progress-bar-animated {
    -webkit-animation: progress-bar-stripes 1s linear infinite;
    animation: progress-bar-stripes 1s linear infinite;
  }

  .truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  six-badge {
    cursor: pointer;
  }

  vaadin-accordion-panel {
    position: relative !important;
  }

  hr.seperator {
    overflow: inherit;
    border: 0px;
    border-bottom: 1px solid #ccc;
    width: 100%;
  }

  .image-wrapper {
    max-height: 400px;
    text-align: center;
    background-color: rgba(71, 92, 123, 0.4);
    padding: 20px;
  }

  .image-wrapper img {
    max-height: 360px;
    width: 100%;
    margin: 0 auto;
  }

  .button-space {
    margin-left: 10px !important;
    float: left !important;
  }

  .counter {
    color: var(--app-primary-color);
    margin: 0px;
    font-size: 16px;
    font-weight: 500;
    line-height: 26px;
    height: 26px;
    float: right;
    margin-top: 10px;
  }

  .counter svg {
    height: 20px !important;
  }

  .counter .wrapper {
    /* empty */
  }

  .counter .wrapper .active {
    font-weight: bold;
    background-color: #d2ddec;
    padding: 0px 8px;
    border-radius: 4px 0px 0px 4px;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    float: left;
  }

  .counter .wrapper .total {
    font-weight: bold;
    background-color: var(--app-primary-color);
    padding: 0px 8px;
    color: #fff;
    border-radius: 0px 4px 4px 0px;
    height: 26px;
    line-height: 26px;
    font-size: 14px;
    float: left;
  }

  .lampeggiante.alert {
    border: 0px solid #ccc;
    -webkit-border-radius: 50%;
    -webkit-animation: pulsate 1s ease-out;
    -webkit-animation-iteration-count: infinite;
    opacity: 0;
    border-radius: 3px;
    height: 26px;
    line-height: 26px;
    padding-left: 6px;
  }
  @-webkit-keyframes pulsate {
    0% {
      -webkit-transform: scale(1, 1);
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(1, 1);
      opacity: 0;
    }
  }

  .alert .icon {
    float: left;
    width: 24px;
  }

  .mt-5 {
    margin-top: 5px !important;
  }

  .mt-10 {
    margin-top: 10px !important;
  }

  .mt-15 {
    margin-top: 15px !important;
  }

  .mt-20 {
    margin-top: 20px !important;
  }

  .mt-22 {
    margin-top: 22px !important;
  }

  .mt-25 {
    margin-top: 25px !important;
  }

  .mr-5 {
    margin-right: 5px !important;
  }

  .mr-10 {
    margin-right: 10px !important;
  }

  .mb-10 {
    margin-bottom: 10px !important;
  }

  .dinamic-warehouse-item {
    background-color: #fff;
    border-bottom: 1px solid #ccc;
    list-style: none;
    color: var(--app-primary-color);
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    padding: 10px 8px 10px 8px;
    margin: 0px;
  }

  .dinamic-warehouse-item .number {
    font-size: 20px;
    font-weight: 700;
  }

  .dinamic-warehouse-item .icon {
    width: 27px;
    height: 27px;
  }

  .dinamic-warehouse-item h3 {
    font-size: 15px;
    margin: 0px 0px;
    margin-top: 3px;
  }

  .dinamic-warehouse-item p {
    font-size: 15px;
    margin: 0px 0px;
  }

  .dinamic-warehouse-item:hover {
    background-color: rgba(67, 82, 99, 0.1);
    transition: transform 0.4s ease-out, -webkit-transform 0.4s ease-out;
  }

  .dinamic-warehouse-item.active {
    background-color: rgba(67, 82, 99, 0.1);
    transition: transform 0.4s ease-out, -webkit-transform 0.4s ease-out;
  }

  .icon-container-green {
    color: var(--app-section-even-color);
    background-color: var(--app-success-color);
    height: 28px;
    line-height: 26px;
    text-align: center;
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    width: 30px;
    border-radius: 3px !important;
    border: 1px solid var(--app-success-color) !important;
  }

  .icon-container-yellow {
    color: var(--app-section-even-color);
    background-color: var(--app-warning-color-2);
    height: 28px;
    line-height: 26px;
    text-align: center;
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    width: 30px;
    border-radius: 3px !important;
    border: 1px solid var(--app-warning-color-2) !important;
  }

  .icon-container-blue {
    background-color: var(--app-primary-color);
    height: 28px;
    line-height: 26px;
    text-align: center;
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    width: 30px;
    border-radius: 3px !important;
    border: 1px solid var(--app-primary-color) !important;
  }

  .icon-container-red {
    color: #fff;
    background-color: #ff4b3e;
    line-height: 26px;
    text-align: center;
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    width: 30px;
    border-radius: 3px !important;
    border: 1px solid #ff4b3e !important;
  }

  .icon-container-green:hover {
    background-color: transparent;
    cursor: pointer;
  }

  .icon-container-yellow:hover {
    background-color: transparent;
    cursor: pointer;
  }

  .icon-container-red:hover {
    background-color: transparent;
    height: 28px;
    cursor: pointer;
  }

  .icon-container-blue .white {
    color: #fff !important;
    width: 17px;
  }
  .icon-container-blue:hover {
    background-color: transparent;
    height: 28px;
    border: 1px solid var(--app-primary-color) !important;
    cursor: pointer;
  }

  .icon-container-disabled .white {
    color: #999 !important;
    width: 17px;
  }

  .icon-container-blue:hover .white {
    color: var(--app-primary-color) !important;
  }

  .icon-container-yellow:hover .white {
    color: var(--app-warning-color-2) !important;
  }

  .icon-container-red:hover .white {
    color: #ff4b3e !important;
  }

  .icon-container-green:hover .white {
    color: var(--app-success-color) !important;
  }

  .icon-container-disabled {
    background-color: #efefef;
    height: 28px;
    line-height: 26px;
    text-align: center;
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    width: 30px;
    border-radius: 3px !important;
    pointer-events: auto !important;
    cursor: not-allowed !important;
    border: 1px solid #ddd;
  }

  .icon-container {
    background-color: transparent;
    height: 28px;
    line-height: 26px;
    text-align: center;
    -webkit-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -moz-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    -o-transition: color 300ms, background-color 300ms, box-shadow 700ms;
    transition: color 300ms, background-color 300ms, box-shadow 700ms;
    width: 30px;
  }

  h3.descriptive-info {
    border: 1px dotted blue;
    min-height: 20px;
    padding: 2px;
  }

  h3.product-title {
    font-size: 13px;
    background-color: #efefef;
    padding: 0px 10px;
    margin: 0px;
    margin-bottom: 0px;
    line-height: 28px;
    height: 28px;
    border-radius: 2px;
  }

  .row.featured-list {
    font-size: 14px;
    border-bottom: 1px dotted #ddd;
    padding: 4px 0px;
  }
  .row.featured-list:hover {
    background-color: #f8f8f8;
  }
  .row.featured-list:last-of-type {
    font-size: 14px;
    border-bottom: 0px solid #ccc;
  }

  h3.product-title:hover {
    background-color: #ddd;
  }

  .accordion-body {
    padding: 20px 0px;
  }

  .search-selected-wrapper {
    padding: 0px 0px 15px 0px;
  }

  .search-selected-wrapper h3 {
    float: left;
    font-size: 13px;
    margin: 0px;
    padding: 0px;
    color: var(--app-primary-color);
    margin-right: 10px;
    line-height: 28px;
  }

  .priority-wrapper {
    padding: 5px 0px;
  }

  .timeline-wrapper {
    padding: 0px;
  }

  .error-msg {
    margin-left: 5px;
    font-size: 13px;
    line-height: 16.25px;
    color: rgb(245, 36, 25);
    will-change: max-height;
    transition: 0.4s max-height;
    max-height: 5em;
  }

  .error-msg:not(:empty)::before,
  .error-msg:not(:empty)::after {
    content: '';
    display: block;
    height: 0.4em;
  }

  .center-host {
    position: relative;
  }

  .center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .pointer {
    cursor: pointer;
  }

  .blink {
    animation: blinker 2s linear infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }

  .h-128 {
    height: 32rem;
  }

  .h-256 {
    height: 64rem;
  }

  .blink-2s {
    animation: blinker 2s linear;
  }
`
/***/},
/***/sBBS:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }
`
/***/},
/***/t1iC:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return i}));
/* harmony import */var r=o("Rukz");
/* harmony import */o("h/KH");const i=r.c`


  paper-fab {
    --paper-fab-background: var(--app-primary-color);
    position: fixed;
    right: 25px;
    bottom: 30px;
  }

  :host {
    color: var(--lumo-body-text-color);
    overflow-y: auto;
    padding: 0px;
    margin: 0px !important;
  }

  .no-margin {
    padding: 0px;
    margin: 0px;
  }

  .login-page {
    height: 100vh;
    position: relative;
  }

  .color-background {
    background-color: transparent;
    height: auto;
    top: 0px;
    opacity: 1;
    bottom: 60px;
    right: 30px;
    position: absolute;
    z-index: 10;
  }

  .color-background img {
    height: 150px;
  }

  .login-wrapper {
    background-color: rgba(24, 39, 57, 0.9);
    height: auto;
    width: 400px;
    top: 200px;
    left: 10%;
    position: absolute;
    z-index: 11;
    border-radius: 4px;
  }

  .login-form-wrapper {
    padding: 60px 40px 40px 40px;
  }

  .login-wrapper .logo {
    height: 40px;
    margin: 0 auto;
    text-align: center;
  }

  .login-image-wrapper {
    height: 100vh;
    background-color: #475c7b;
  }

  .form-group {
    margin-bottom: 10px;
  }

  .login-logo-wrapper {
    height: 50px;
    text-align: center;
    margin-bottom: 10px;
  }

  .login-logo-wrapper img {
    height: 50px;
    margin: 0 auto;
  }

  .login-wrapper .logo img {
    height: 40px;
    margin: 0 auto;
  }

  .page {
    margin: 0px !important;
  }

  :host[active] {
    display: block;
    margin-left: 0px;
  }
`
/***/},
/***/"uma+":
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/vH64:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/},
/***/vL5H:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  paper-dialog {
    width: 85%;
    max-width: 85%;
    height: 500px;
    max-height: 500px;
  }
`
/***/},
/***/xBL0:
/***/function(c,t,o){"use strict";
/* harmony export (binding) */o.d(t,"a",(function(){return r}));const r=o("Rukz").c`
  .hidden {
    display: none;
  }

  hr {
    border: 0px;
    border-bottom: 1px solid #ccc;
  }
`
/***/}}]);